import { Transition } from "@headlessui/react";
import { MessageCircle, MessageSquareText } from "lucide-react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import downArrow from "src/assets/down-arrow.svg";
import starEmpty from "src/assets/starEmpty.svg";
import SuccessIcon from "src/assets/successCircle.svg";
import { Autocomplete, Button, Checkbox, Input, Modal, Spinner, Toggle } from "src/components"; // M10-13377
import crossIcon from "src/assets/cross.svg"; // M10-13377
import VersioningCrate from "src/components/Versioning/versioningModal.component";
import { invoiceActions } from "src/context/invoice-slice";
import { RootState } from "src/context/store";
import Download from "src/features/fields/assets/Download copy.svg";
import star from "src/features/fields/assets/star.svg";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import { useToast } from "src/hooks/useToast";
import {
  downloadInvoice,
  editInvoice,
  getInvoiceActionAllowed,
  getInvoiceChangeValidationV1,
  getInvoiceDetails,
  getSimilarOrders,
  postInvoicePackChange,
  searchProduct,  //M10-14632
} from "src/services/invoice-api";
import Book from "../../assets/book.png";
import PurpleLeftArrowIcon from "../../assets/purple-left-arrow.svg";
import { DEFAULT_TABLE_DATA, getFinancialYear, getInvoiceDetailsInfo } from "../invoice-master/invoice-helper";
import InvoiceLayout from "../invoice-master/invoice-layout.component";
import InvoiceDetailCard from "./invoice-detail.component";
import InvoiceReject from "./invoice-reject";
import InvoiceApprovalOrderedData from "./InvoiceApprovalCards/ApprovalOrderedData";
import NetAmountCompare from "./InvoiceApprovalCards/NetAmountCompare";
import RecallInvoice from "./InvoiceApprovalCards/RecallInvoice";
import RevertInvoice from "./InvoiceApprovalCards/RevertInvoice";
import InvoiceRemarks from "./InvoiceRemarks";
import PartialIcon from "src/assets/partial.svg";
import IsDifferentOrder from "./InvoiceApprovalCards/IsDifferentOrder";
import PerStripOrderEdit, { packEquivalentPrice } from "./InvoiceApprovalCards/PerStripOrderEdit";
import IsDifferentPoRef from "./InvoiceApprovalCards/IsDifferentPoRef";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import usePermission from "src/hooks/usePermission";
import useDebounceLeading from "src/hooks/useDebounceLeading";
// M10-12438
import { removePoApi } from "src/services/po-api";
import { PORemoveModalReusable } from "src/components/ui/PORemoveModal";
import AddFeedbackForm from "../feedback/add-feedback-form.component";
import { addFeedback } from "src/services/feedback-api";
// M10-12438

// M10-16200: category 1 e-invoice status badge colors
const cat1EinvoiceStatusColor: Record<string, string> = {
  pending: "text-[#92400E] bg-[#FEF3C7]",
  accepted: "text-[#207a65] bg-[#d3f6e4]",
  rejected: "text-[#B42318] bg-[#FEE4E2]",
};

const subtleColors = ["#F9F9FF", "#EFF8FF", "#F3FFF4", "#FFF5F5", "#FDFCF7", "#F3F0FF", "#EFFFFA", "#FFF3F7", "#F0FBFF", "#F7F5FF"];

export const InvoiceApprovalScreen = () => {
  const { stockist_invoice_attachment_id } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { invoiceApprovalData, tempDate } = useSelector((state: RootState) => state.invoice); //M10-12020
  const { idTokenDetails } = useSelector((state: RootState) => state.auth);
  const [mappedData, setMappedData] = useState<any[]>([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState<any>(null);
  const [tableData, setTableData] = useState(DEFAULT_TABLE_DATA);
  const { toast } = useToast();
  const [productsData, setProductsData] = useState<any[]>(invoiceApprovalData?.invoice?.invoiceProducts);
  const [orderedData, setOrderedData] = useState<any[]>([]);
  const [similarOrders, setSimilarOrders] = useState<any[]>([]);
  const [tcs, setTcs] = useState<number | any>(0);
  const [selectedOrders, setSelectedOrders] = useState<any[]>([]);
  const navigate = useNavigate();
  const [isRemarksShown, setIsRemarksShown] = useState(false);
  const [showOrderDropdown, setShowOrderDropdown] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [VersioningModal, setVersioningModal] = useState(false);
  const [remainingQuantity, setRemainingQuantity] = useState<any[]>([]);
  const [revertInvoiceOpen, setRevertInvoiceOpen] = useState<boolean>(false);
  const [recallInvoiceOpen, setRecallInvoiceOpen] = useState<boolean>(false);
  const [rejectInvoiceOpen, setRejectInvoiceOpen] = useState<boolean>(false);
  const [openNetAmtModal, setOpenNetAmtModal] = useState<boolean>(false);
  const [entryNetAmt, setEntryNetAmt] = useState<string>("");
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [checkedRows, setCheckedRows] = useState<Set<string>>(new Set());
  const [isDifferentOrderModalOpen, setIsDifferentOrderModalOpen] = useState<boolean>(false);
  const [packChangeMessage, setPackChangeMessage] = useState<string>("");
  const [openPerStripModal, setOpenPerStripModal] = useState<boolean>(false);
  // Runs the pack change once its popup is answered (true = Yes).
  const perStripContinueRef = useRef<((confirmed: boolean) => void) | null>(null);
  // One-shot: the modal can fire close and decline for the same answer.
  const resumePerStripSave = (confirmed: boolean) => {
    const resume = perStripContinueRef.current;
    perStripContinueRef.current = null;
    setOpenPerStripModal(false);
    resume?.(confirmed);
  };
  const [isDifferentPoRefModalOpen, setIsDifferentPoRefModalOpen] = useState<boolean>(false);
  const [removePOmodel, setRemovePOmodel] = useState<boolean>(false);
  const [orderToSelect, setOrderToSelect] = useState<any[]>([]);
  const [isExpanded, setIsExpanded] = useState(true);
  const [isMapped, setIsMapped] = useState(true); //M10-11117
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  // M10-13377
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verifyData, setVerifyData] = useState<any>(null);
  const [isVerified, setIsVerified] = useState(false);
  const [isConfirmScheme, setIsConfirmScheme] = useState(true)
  // M10-13377

  //M10-9862
  const location = useLocation();
  // Fall back to the company_code stored in localStorage when opened in a new
  // tab (react-router location.state is not available across a fresh tab load).
  const { CompanyCode: companyCodeFromState } = location.state || {};
  const CompanyCode = companyCodeFromState || window.localStorage.getItem("company_code");
  // const [isAutoApproving, setIsAutoApproving] = useState<boolean>(false);
  const company_code = invoiceApprovalData?.company_code;
  const { hasPermission: viewRemarks } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.module,
    action: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.action,
  });
  //M10-15191
  const { hasPermission: hasPermissionInvoicePreDate } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.INVOICEPREDATE.module,
    action: fineGrainedPermissionsKeys.INVOICE.INVOICEPREDATE.action,
  });
  //M10-15191

  const getRowId = (item: any, index: number) => `${item.unique_key}-${index}`;

  // Same product, different batches: every other batch checked in the "Select" column for the
  // product currently being viewed rides along as its own line item, sharing the pricing decided
  // in the panel below. Computed here (render scope, not just inside handleSaveModifiedData) so a
  // read-only preview of each sibling batch can be shown on screen before Save, and reused by
  // handleSaveModifiedData so what gets saved always matches what was previewed. Scheme orders
  // never bulk-map — even if boxes were checked before a Scheme order was chosen, the Select
  // checkboxes are only disabled going forward, so this is the backstop.
  const siblingBatches = selectedOrders?.[0]?.price_identifier === 2
    ? []
    : selectedProducts.filter(
        (p) => p.item_code === selectedItemDetails?.item_code && p.unique_key !== selectedItemDetails?.unique_key
      );
  const isBulkBatchMapping = siblingBatches.length > 0;
  // M10-15595: always save whatever Discount % is actually shown in the Modified Data column —
  // previously this forced the order's raw discount_on_ptr for a bulk-mapped Discount-on-PTR
  // selection, silently discarding a user-entered Modified Discount % (e.g. 34.43 saved as 35).
  const finalDiscountPerc = Number(tableData.find((item) => item.type === "Discount %")?.modifiedData);

  // M10-15357: when multiple batches of the same item are checked in the "Select" column, the
  // "Select an Item" panel's Invoice Data column should reflect what was invoiced across all of
  // them combined (Quantity/Scheme Qty summed, Discount % amount-weighted), not just the single
  // batch that happened to open the panel. Display-only — derived from selectedItemDetails +
  // siblingBatches, so the underlying invoice rows, Modified Data, and the separate-line-item
  // Save logic are untouched.
  const combinedInvoiceBatches = selectedItemDetails ? [selectedItemDetails, ...siblingBatches] : [];
  const combinedInvoiceQuantity = combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.quantity) || 0), 0);
  const combinedInvoiceSchemeQty = combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.free_qty) || 0), 0);
  const combinedInvoiceGrossAmt = combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.gross_amt) || 0), 0);
  const combinedInvoiceDiscountAmt = combinedInvoiceBatches.reduce((sum, b) => {
    const discountAmt = Number(b?.discount_amt) || ((Number(b?.gross_amt) || 0) * (Number(b?.discount_perc) || 0)) / 100;
    return sum + discountAmt;
  }, 0);
  // M10-15357: amount-weighted discount % from the group's Discount Percent / Fixed Price
  // batches only. A Scheme batch's discount_amt/discount_perc are always 0 (its discount is
  // expressed as free qty, not amount/percent — see M10-15328 above), so this naturally excludes
  // Scheme batches rather than treating their missing discount as a real 0%.
  const combinedInvoicePercentDiscount = combinedInvoiceGrossAmt > 0 ? (combinedInvoiceDiscountAmt / combinedInvoiceGrossAmt) * 100 : 0;
  // M10-15357: fold each Scheme batch's free qty into an equivalent discount % across the
  // group's combined paid + free units — the same conversion already used for a single Scheme
  // row (equivalentSchemeDiscountPerc/schemeFree below: free qty ÷ (free qty + paid qty) × 100),
  // just applied to the combined totals instead of one row.
  const combinedInvoiceSchemeEquivalentPercent =
    combinedInvoiceQuantity + combinedInvoiceSchemeQty > 0
      ? (combinedInvoiceSchemeQty / (combinedInvoiceQuantity + combinedInvoiceSchemeQty)) * 100
      : 0;
  // Compounded (not summed), mirroring the existing totalDiscountcalculation/
  // getEffectiveInvoiceDiscountPercent "successive discount" pattern (A + (100-A)*B/100) — a
  // group with no Scheme batches (combinedInvoiceSchemeEquivalentPercent === 0) falls back to
  // exactly the amount-weighted percent discount above, and no batch's discount is ever counted
  // through both the percent-amount path and the scheme-qty path at once.
  const combinedInvoiceDiscountPercent =
    combinedInvoicePercentDiscount + ((100 - combinedInvoicePercentDiscount) * combinedInvoiceSchemeEquivalentPercent) / 100;
  // M10-15357: combined not-yet-mapped capacity across every selected batch of this item — the
  // basis for "does this modification fit within what's actually left on the invoice" checks
  // below, so a multi-row selection is capped against the group's total capacity instead of just
  // the batch that opened the panel.
  const combinedInvoiceUnmappedQty = combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.unmappedQty) || 0), 0);
  const combinedInvoiceUnmappedFreeQty = combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.unmappedFreeQty) || 0), 0);
  // M10-15357: "Quantity cannot exceed what was actually invoiced" cap, capacity-aware for a
  // bulk selection — a Scheme sibling's free qty is about to be folded fully into Quantity when
  // saved (handleSaveModifiedData's siblingCapacityTotal already does this unconditionally for
  // every sibling), so the cap must count each batch's quantity + free qty together, not just
  // its quantity field, or a Scheme sibling's units would be invisible to this check even though
  // they're part of what the Modified Quantity total is allowed to cover. Falls back to the
  // exact single-row values (no folding) outside a bulk selection, matching prior behavior.
  const combinedInvoiceQuantityCapacity = isBulkBatchMapping
    ? combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.quantity) || 0) + (Number(b?.free_qty) || 0), 0)
    : combinedInvoiceQuantity;
  const combinedInvoiceUnmappedQuantityCapacity = isBulkBatchMapping
    ? combinedInvoiceBatches.reduce((sum, b) => sum + (Number(b?.unmappedQty) || 0) + (Number(b?.unmappedFreeQty) || 0), 0)
    : combinedInvoiceUnmappedQty;

  const getInvoiceDataDisplayValue = (row: any) => {
    if (!isBulkBatchMapping) return row?.invoiceData;
    switch (row?.type) {
      case "Quantity":
        return combinedInvoiceQuantity;
      case "Scheme Qty":
        return combinedInvoiceSchemeQty;
      case "Discount %":
        return combinedInvoiceDiscountPercent.toFixed(2);
      default:
        return row?.invoiceData;
    }
  };

  // Builds the line item that will actually be saved for a sibling batch: its own quantity
  // (free/scheme qty folded in — a sibling is always mapped under the group's Discount Percent/
  // Fixed Price order type, never Scheme, so it never has a separate Scheme Qty to show), at the
  // Price/PTR/MRP/Cash Discount decided for the batch being edited in the panel below.
  const buildSiblingModifiedItem = (sibling: any) => {
    const siblingBaseQuantity = Number(sibling?.unmappedQty ?? sibling?.quantity ?? 0);
    const siblingBaseFreeQty = Number(sibling?.unmappedFreeQty ?? sibling?.free_qty ?? 0);
    const siblingQuantity = siblingBaseQuantity + siblingBaseFreeQty;
    const modifiedPrice = tableData.find((item) => item.type === "Price")?.modifiedData;
    const siblingBaseKey = `${sibling?.item_code}~${sibling?.batch_no}~${sibling?.inv_mrp}~${sibling?.inv_rate}~${selectedOrders?.[0]?.id}`;
    const siblingExistingCount = mappedData.filter((item) => item.unique_key?.startsWith(siblingBaseKey)).length;
    return {
      ...sibling,
      quantity: siblingQuantity,
      free_qty: 0,
      discount_perc: finalDiscountPerc,
      discount_type: selectedOrders?.[0]?.price_identifier === 1 ? "Discount Percent" : "Fixed Price",
      cash_discount: tableData.find((item) => item.type === "Cash Discount")?.modifiedData,
      ptr: tableData.find((item) => item.type === "PTR")?.modifiedData,
      inv_mrp: tableData.find((item) => item.type === "MRP")?.modifiedData,
      inv_rate: modifiedPrice,
      gross_amt: Number(modifiedPrice) * siblingQuantity,
      fixed_price: selectedOrders?.[0]?.price_identifier === 3 ? modifiedPrice : null,
      invoice_id: invoiceApprovalData?.invoice?.invoice_id,
      company_stockist_code: String(invoiceApprovalData?.company_stockist_code),
      counter_code: invoiceApprovalData?.counter_code,
      order_code: selectedOrders?.map((item: any) => item?.id),
      p_cash_discount_perc: Number(tableData.find((item) => item.type === "Cash Discount")?.modifiedData),
      merged: true,
      unique_key: `${siblingBaseKey}~${siblingExistingCount + 1}`,
    };
  };

  const siblingModifiedItems = siblingBatches.map(buildSiblingModifiedItem);

  const uniqueKeyColorMap: Record<string, string> = {};
  let colorIndex = 0;

  mappedData.forEach((item) => {
    if (!uniqueKeyColorMap[item.unique_key?.split("~")?.slice(0, 5)?.join("~")]) {
      uniqueKeyColorMap[item.unique_key?.split("~")?.slice(0, 5)?.join("~")] = subtleColors[colorIndex % subtleColors.length];
      colorIndex++;
    }
  });

  const outSideClickRef = useOutsideClick(() => {
    setVersioningModal(false);
  });
  const { withEventCheck, isBlocked: isInvoiceEventBlocked } = useEventStatus();  //M10-15287

  const inputRef = useRef<HTMLInputElement>(null);
  const ref = useOutsideClick(() => {
    setIsRemarksShown(false);
  });

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const fetchInvoiceDetails = async () => {
    setIsLoading(true);
    try {
      const response = await getInvoiceDetails(stockist_invoice_attachment_id as string, false, CompanyCode);
      dispatch(invoiceActions.setInvoiceApprovalData(response?.data?.data));
      //M10-9685-MRP Related Issue
      const productsDataStateTobeSaved = response?.data?.data?.invoice?.invoiceProducts
        ?.filter((item: any) => item?.is_confirmed)
        ?.map((item: any) => ({
          ...item,
          unmappedQty: item?.quantity,
          unmappedFreeQty: item?.free_qty,
          // M10-15034: include MRP + Price so two rows with the same item code and batch
          // but different pricing are tracked as distinct lines, not merged/blocked together.
          unique_key: `${item?.item_code}~${item?.batch_no}~${item?.inv_mrp}~${item?.inv_rate}`,
        }));
      //M10-9685-MRP Related Issue
      setProductsData(productsDataStateTobeSaved);
      setEntryNetAmt(response?.data?.data?.invoice?.net_amount);
      setOrderedData(
        response?.data?.data?.invoice?.invoiceProducts?.flatMap(
          (item: any) =>
            //M10-14198
            item?.orderProductMappings?.map((mapping: any) => {
              const useOrderProduct = mapping?.orderProduct?.replaced_products?.length > 0;
              return {
                ...mapping,
                item_description: useOrderProduct ? mapping?.orderProduct?.product_name : item?.item_description,
                item_code: useOrderProduct ? mapping?.orderProduct?.item_code : item?.item_code,
                entered_item_code: item?.item_code,
                inv_mrp: item?.inv_mrp,
                ptr: item?.ptr,
                price_identifier: item?.discount_type,
                batch_no: item?.batch_no,
                inv_rate:item?.inv_rate
              };
            }) || []
             //M10-14198
        )
      );
      if (response?.data?.data?.invoice?.auto_approved?.length > 0) {
        setMappedData(response?.data?.data?.invoice?.auto_approved);
        toast({ title: "Auto approving", description: "Invoice products are auto approved", variant: "default" });
      }
      // if (response?.data?.data?.fileStatusHdr?.fuid_status_id !== 8) {
      //   handleAutoApprovalOfSchemeTypeInvoiceAndOrder(productsDataStateTobeSaved, response?.data?.data);
      // }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (e: any, item: any, index: number) => {
    const rowId = getRowId(item, index);

    setCheckedRows((prev) => {
      const newSet = new Set(prev);
      if (e.target.checked) {
        newSet.add(rowId);
      } else {
        newSet.delete(rowId);
      }
      return newSet;
    });

    if (e.target.checked) {
      setSelectedProducts((prev) => {
        const existing = prev.find((p) => p.unique_key === item.unique_key);
        if (existing) {
          return prev.map((p) =>
            p.unique_key === item.unique_key
              ? {
                ...p,
                quantity: p.quantity + item.quantity,
                free_qty: p.free_qty + item.free_qty,
                unmappedQty: p.unmappedQty + item.quantity,
                unmappedFreeQty: p.unmappedFreeQty + item.free_qty,
              }
              : p
          );
        } else {
          return [...prev, { ...item }];
        }
      });
    } else {
      // Unchecking this row — need to subtract this item's quantities
      setSelectedProducts((prev) => {
        const updated = prev.map((p) => {
          if (p.unique_key === item.unique_key) {
            return {
              ...p,
              quantity: p.quantity - item.quantity,
              free_qty: p.free_qty - item.free_qty,
              unmappedQty: p.unmappedQty - item.quantity,
              unmappedFreeQty: p.unmappedFreeQty - item.free_qty,
            };
          }
          return p;
        });

        // If quantities zeroed, remove the item
        return updated.filter((p) => p.quantity > 0 || p.free_qty > 0);
      });
    }
  };

  const calculateTotalCashDiscountPercentage = () => {
    const totalCashDiscount = calculateTotalCashDiscount();
    const totalSubtotal = calculateSubtotal();
    return (totalCashDiscount / totalSubtotal) * 100;
  };

  const calculateTotalCashDiscount = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const { gross_amt, discount_perc, p_cash_discount_perc } = item;
      const afterItemDiscount = Number(gross_amt) - (Number(gross_amt) * Number(discount_perc)) / 100;
      const cashDiscountAmount = (afterItemDiscount * Number(p_cash_discount_perc)) / 100;
      total += cashDiscountAmount;
    });
    return total;
  };

  // const subtotal = mappedData?.reduce((acc: number, item: any) => acc + Number(item?.quantity) * Number(item?.ptr), 0);
  const calculateSubtotal = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const { gross_amt, discount_perc } = item;
      const cashDiscountAmount = (gross_amt * Number(discount_perc)) / 100;
      total += gross_amt - cashDiscountAmount;
    });
    return total;
  };

  const calculateTotalGst = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const { gross_amt, p_gst_perc, discount_perc, p_cash_discount_perc } = item;
      // Calculate GST on amount after discount
      let amountAfterItemDiscount = Number(gross_amt) - (Number(gross_amt) * Number(discount_perc)) / 100;
      let amountAfterCashDiscount = amountAfterItemDiscount - (amountAfterItemDiscount * Number(p_cash_discount_perc)) / 100;

      const gstAmount = (amountAfterCashDiscount * Number(p_gst_perc)) / 100;
      total += gstAmount;
    });
    return total;
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const amountAfterCashDiscount = subtotal - calculateTotalCashDiscount();
    const totalGst = calculateTotalGst();
    const tcsCalculatedAmount = amountAfterCashDiscount + totalGst + ((amountAfterCashDiscount + totalGst) * tcs) / 100;
    // return amountAfterCashDiscount + totalGst;
    return tcsCalculatedAmount;
  };

  const calculateTotalCashDiscountNew = () => {
    let total = 0;
    invoiceApprovalData?.invoice?.invoiceProducts?.forEach((item: any) => {
      const { gross_amt, discount_perc, p_cash_discount_perc } = item;
      const afterItemDiscount = Number(gross_amt) - (Number(gross_amt) * Number(discount_perc)) / 100;
      const cashDiscountAmount = (afterItemDiscount * Number(p_cash_discount_perc)) / 100;
      total += cashDiscountAmount;
    });
    return total;
  };

  const calculateTotalGstnew = () => {
    let total = 0;
    invoiceApprovalData?.invoice?.invoiceProducts?.forEach((item: any) => {
      const { gross_amt, p_gst_perc, discount_perc, p_cash_discount_perc } = item;
      // Calculate GST on amount after discount
      let amountAfterItemDiscount = Number(gross_amt) - (Number(gross_amt) * Number(discount_perc)) / 100;
      let amountAfterCashDiscount = amountAfterItemDiscount - (amountAfterItemDiscount * Number(p_cash_discount_perc)) / 100;

      const gstAmount = (amountAfterCashDiscount * Number(p_gst_perc)) / 100;
      total += gstAmount;
    });
    return total;
  };
  const calculateTotalAsFinal = () => {
    const subtotal = Number(invoiceApprovalData?.invoice?.gross_amount || 0);
    const amountAfterCashDiscount = subtotal - calculateTotalCashDiscountNew();
    const totalGst = calculateTotalGstnew();
    const tcsCalculatedAmount = amountAfterCashDiscount + totalGst + ((amountAfterCashDiscount + totalGst) * tcs) / 100;
    // return amountAfterCashDiscount + totalGst;
    return tcsCalculatedAmount;
  };

  const handleViewDetails = async (item: any) => {
    setSelectedOrders([]);
    setSelectedItemDetails(null);
    // setMappedData((prev) => prev.filter((mappedItem) => mappedItem.unique_key !== item.unique_key));
    try {
      const response = await getSimilarOrders({
        item_code: item?.item_code,
        inv_mrp: item?.inv_mrp,
        counter_code: invoiceApprovalData?.counter_code,
        company_stockist_code: invoiceApprovalData?.company_stockist_code,
        ...(hasPermissionInvoicePreDate && { temp_invoice_date: tempDate }), //M10-12020  //M10-15191
        company_code: invoiceApprovalData?.company_code,
        invoice_date: invoiceApprovalData?.invoice?.new_invoice_date,   //M10-12020
        batch_no :  item?.batch_no, //M10-14279
        stockist_invoice_attachment_id: invoiceApprovalData?.stockist_invoice_attachment_id,
      });

      toast({
        title: "Data Fetched Successfully",
        description: "Data has been fetched successfully.",
      });

      setSimilarOrders(response?.data?.data);
      setSelectedItemDetails(item);

      //if uniquekey+batch is not present in remainingQuantity, then add it //M10-14279
      const hasBatchInSimilarOrders = response?.data?.data?.some((orderItem: any) => orderItem?.batch_number); //M10-14279
      const incomingKey = hasBatchInSimilarOrders
        ? item?.unique_key?.split("~").slice(0, 4).join("~")
        : item?.unique_key?.split("~")[0];
      setRemainingQuantity((prev) => {
        const existingIndex = prev.findIndex((product) => product?.unique_key === incomingKey);
        //M10-13888
        const freshOrders = response?.data?.data?.map((orderItem: any) => ({
          order_code: orderItem?.order?.order_code,
          remaining_quantity: orderItem?.remaining_quantity ?? 0,
          remaining_free_quantity: orderItem?.remaining_free_quantity ?? 0,
        })) ?? [];

        if (existingIndex !== -1) {
          const prevOrders = prev[existingIndex]?.orders ?? [];
          // Reconcile with latest API response: keep decremented entries for orders
          // still present; drop stale orders that are no longer returned; add new ones.
          const mergedOrders = freshOrders.map((fresh: any) => {
            const carry = prevOrders.find((o: any) => o?.order_code === fresh.order_code);
            return carry ? carry : fresh;
          });

          const updated = [...prev];
          updated[existingIndex] = {
            ...updated[existingIndex],
            orders: mergedOrders,
            // M10-15287: use the invoice line's remaining (not-yet-mapped) qty/free-qty here —
            // item?.quantity/free_qty are the static original invoice values and stay constant
            // across re-selections, which caused already-mapped free qty to be re-offered when
            // the same line was mapped to a second order.
            remaining_invoice_quantity: item?.unmappedQty,
            remaining_invoice_free_quantity: item?.unmappedFreeQty,
          };
          return updated;
        } else {
          return [
            ...prev,
            {
              unique_key: incomingKey,
              orders: freshOrders,  //M10-13888
              remaining_invoice_quantity: item?.unmappedQty,
              remaining_invoice_free_quantity: item?.unmappedFreeQty,
            },
          ];
        }
      });

      requestAnimationFrame(() => {
        setTimeout(() => {
          if (inputRef.current) {
            // Store the original styles
            const originalBorder = inputRef.current.style.border || "1px solid #d1d5db"; // Default Tailwind gray-300
            const originalBoxShadow = inputRef.current.style.boxShadow || "none";

            // Focus and apply new styles
            inputRef.current.focus();
            inputRef.current.style.boxShadow = "0 0 0 2px #8051FF";

            // Add blur event listener to reset styles
            const resetStyles = () => {
              if (inputRef.current) {
                inputRef.current.style.border = originalBorder;
                inputRef.current.style.boxShadow = originalBoxShadow;
              }
            };

            // Remove any existing listener to prevent duplicates
            inputRef.current.removeEventListener("blur", resetStyles);
            // Add the blur listener
            inputRef.current.addEventListener("blur", resetStyles, { once: true });
          }
        }, 100);
      });
      setShowOrderDropdown(true);
    } catch (error: any) {
      console.log(error);
      setSimilarOrders([]); //M10-12020
      toast({
        title: error?.response?.data?.error,
        description: error?.response?.data?.message,
        variant: "destructive",
      });
    }
  };

  useEffect(() => {
    if (!selectedItemDetails) return;
    let modifiedQuantity;
    let modifiedFreeQty;

    let remainingQty;
    let OrdRemainingFreeQty;
    let OrdDiscountType;
    let OrdQuantity;

    let discountInv;
    let discountOrd;
    let InvQty;
    let InvFreeQty;
    let fixed_price;
    let InvDiscPerc;
    let InvDiscAmt;
    let InvDiscountType;

    let selectedItemUniqueKey = (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]);

    let modifiedDiscountPercent;
    let cashDiscountInvoice = Number(selectedItemDetails?.p_cash_discount_perc) || 0;
    let cashDiscountOrder = Number(selectedOrders?.[0]?.order?.order_cash_discount_perc) || 0;

    remainingQty = remainingQuantity
      ?.find((item) => item?.unique_key === selectedItemUniqueKey)
      ?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_quantity;

    OrdRemainingFreeQty = remainingQuantity
      ?.find((item) => item?.unique_key === selectedItemUniqueKey)
      ?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_free_quantity;

    // M10-15287: use the invoice line's remaining (not-yet-mapped) qty/free-qty as the basis for
    // suggested Modified Data — selectedItemDetails?.quantity/free_qty are the static original
    // invoice values and never shrink, so re-selecting a line already mapped to another order
    // re-offered the same free qty a second time. unmappedQty/unmappedFreeQty equal
    // quantity/free_qty until a mapping is saved, so first-time mapping is unaffected.
    InvQty = selectedItemDetails?.unmappedQty;
    InvFreeQty = selectedItemDetails?.unmappedFreeQty;
    InvDiscPerc = (selectedItemDetails?.discount_amt / selectedItemDetails?.gross_amt) * 100;
    InvDiscAmt = selectedItemDetails?.discount_amt;
    InvDiscountType = selectedItemDetails?.discount_type;

    OrdDiscountType = selectedOrders?.[0]?.price_identifier;
    OrdQuantity = selectedOrders?.[0]?.quantity;

    discountInv = selectedItemDetails?.discount_perc ? selectedItemDetails?.discount_perc : selectedItemDetails?.gross_amt > 0 ? ((selectedItemDetails.discount_amt / selectedItemDetails.gross_amt) * 100).toFixed(2) : "0.00";  

    //When invoice discount type is Discount Percent and order is of scheme then allow equivalent free qty of discount of invoiced quantity
    if ((InvDiscountType == "Discount Percent" || InvDiscountType == "Discount Amount") && InvDiscPerc !== 0 && OrdDiscountType === 2) {
      const allowedFreeQtyRaw = InvQty * (InvDiscPerc / 100);
      modifiedFreeQty = Math.round(allowedFreeQtyRaw);
      modifiedQuantity = InvQty - modifiedFreeQty > remainingQty ? remainingQty : InvQty - modifiedFreeQty;
    }
    //When invoice discount type is Scheme and order is of Discount percent then allow equivalent free qty of discount of ordered quantity
    else if (InvDiscountType == "Scheme" && OrdDiscountType === 1) {
      // const allowedFreeQtyRaw = Math.round(OrdQuantity * (selectedOrders?.[0]?.discount_on_ptr / 100)); //vijay changes
      // Convert scheme units (paid + free) into discount-priced quantity; no free qty on a discount order
      const totalSchemeUnits = Number(InvQty) + Number(InvFreeQty);
      modifiedQuantity = totalSchemeUnits < remainingQty ? totalSchemeUnits : remainingQty;
      modifiedFreeQty = 0;
      // modifiedQuantity = InvQty + allowedFreeQtyRaw; //vijay changes
      // modifiedFreeQty = Math.round(allowedFreeQtyRaw);
      // modifiedQuantity = OrdQuantity - modifiedFreeQty;
    }
    //When invoice discount type is Fixed price and order is of Fixed Price
    else if (
      (InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent" || InvDiscountType == "Scheme") &&
      InvDiscPerc == 0 &&
      InvDiscAmt == 0 &&
      InvFreeQty == 0 &&
      OrdDiscountType === 3
    ) {
      const calculatedQuantity = (remainingQty * selectedOrders?.[0]?.fixed_price) / selectedItemDetails?.inv_rate;
      modifiedQuantity = Math.round(Math.min(selectedItemDetails?.quantity, calculatedQuantity));
      // modifiedFreeQty = remainingQty - modifiedQuantity;
    }
    //When invoice discount type is Fixed price and order is of Scheme then allow equivalent free qty of discount of invoiced quantity
    else if (
      (InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent") &&
      InvDiscPerc == 0 &&
      InvDiscAmt == 0 &&
      OrdDiscountType === 2
    ) {
      const absDiffInPtrAndPrice = Math.abs(selectedOrders?.[0]?.ptr - selectedItemDetails?.inv_rate);
      const allowedFreeQtyRaw = (InvQty * ((absDiffInPtrAndPrice / selectedOrders?.[0]?.ptr) * 100)) / 100;
      modifiedFreeQty = Math.round(allowedFreeQtyRaw);
      modifiedQuantity = Math.min(InvQty - modifiedFreeQty, remainingQty);
    }
    //When invoice discount type is Scheme and order is of Scheme — carry the invoice free qty through as-is
    else if (InvDiscountType == "Scheme" && OrdDiscountType === 2) {
      modifiedQuantity = InvQty < remainingQty ? InvQty : remainingQty;
      modifiedFreeQty = Math.min(Number(InvFreeQty),Number(OrdRemainingFreeQty));
    }
    //When invoice discount type is Scheme  and order is of Fixed price then allow equivalent free qty of discount of ordered quantity
    else if (InvDiscountType == "Scheme" && OrdDiscountType === 3) {
      const absDiffInPtrAndPrice = Math.abs(selectedOrders?.[0]?.fixed_price - selectedItemDetails?.ptr);
      const allowedFreeQtyRaw = (OrdQuantity * ((absDiffInPtrAndPrice / selectedItemDetails?.ptr) * 100)) / 100;
      modifiedFreeQty = Math.round(allowedFreeQtyRaw);
      modifiedQuantity = OrdQuantity - modifiedFreeQty;
    }
    //When invoice discount type is Fixed price and order is Discount on PTR
    else if (
      (InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent") &&
      InvDiscPerc == 0 &&
      InvDiscAmt == 0 &&
      OrdDiscountType === 1
    ) {
      // const invoiceAmount = InvQty * InvRate;
      // const orderAmount = ((OrdQuantity * selectedOrders?.[0]?.ptr)) - ((OrdQuantity * selectedOrders?.[0]?.ptr) * (selectedOrders?.[0]?.discount_on_ptr / 100));
      //if difference of invoice amount and order amount is less than or equal to 1 then allow the quantity of order
      // if (Math.abs(invoiceAmount - orderAmount) <= 1) {
      modifiedQuantity = InvQty < remainingQty ? InvQty : remainingQty;
      modifiedFreeQty = InvFreeQty < OrdRemainingFreeQty ? InvFreeQty : OrdRemainingFreeQty;
      // }
    }
    //When invoice discount type is Discount on PTR and order is of Fixed price
    else if ((InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent") && InvDiscPerc !== 0 && OrdDiscountType === 3) {
      // const invoiceAmount = (InvQty * InvRate) - (InvQty * InvRate) * (InvDiscPerc / 100);
      // const orderAmount = (OrdQuantity * selectedOrders?.[0]?.fixed_price);
      //if difference of invoice amount and order amount is less than or equal to 1 then allow the quantity of order
      // if (Math.abs(invoiceAmount - orderAmount) <= 1) {
      modifiedQuantity = InvQty < remainingQty ? InvQty : remainingQty;
      modifiedFreeQty = InvFreeQty < OrdRemainingFreeQty ? InvFreeQty : OrdRemainingFreeQty;
      // }
    } else {
      if (OrdDiscountType === 2) {
        let totalDiscountPercentage1 = cashDiscountInvoice + ((100 - cashDiscountInvoice) * Number(discountInv)) / 100;
        const allowedFreeQtyRaw = InvQty * (Number(totalDiscountPercentage1) / 100);
        const absDiffInPtrAndPrice = Math.abs(selectedItemDetails?.ptr - selectedItemDetails?.inv_rate);
        const priceGapFreeQtyRaw = InvQty * (absDiffInPtrAndPrice / selectedItemDetails?.ptr);
        let calculatedFreeQty = Number(Math.round(allowedFreeQtyRaw) + Math.round(priceGapFreeQtyRaw) + InvFreeQty);
        modifiedFreeQty = Math.min(calculatedFreeQty, OrdRemainingFreeQty);
        modifiedQuantity = InvQty < remainingQty ? InvQty : remainingQty;
      } else {
        modifiedQuantity = InvQty < remainingQty ? InvQty : remainingQty;
        modifiedFreeQty = InvFreeQty < OrdRemainingFreeQty ? InvFreeQty : OrdRemainingFreeQty;
      }
    }

    discountOrd = (() => {
      switch (OrdDiscountType) {
        case 1:
          return selectedOrders?.[0]?.discount_on_ptr;
        case 3:
          return "Fixed Price : " + selectedOrders?.[0]?.fixed_price;
        default:
          return "0";
      }
    })();

    fixed_price = (() => {
      switch (OrdDiscountType) {
        case 3:
          return selectedItemDetails?.ptr;
        default:
          return selectedItemDetails?.ptr;
      }
    })();

    //different percentage between ptr and price
    const percentageDifference = Math.abs(((selectedItemDetails?.inv_rate - selectedItemDetails?.ptr) / selectedItemDetails?.ptr) * 100).toFixed(2);
    let totalDiscountPercentage1 = cashDiscountInvoice + ((100 - cashDiscountInvoice) * Number(discountInv)) / 100;
    let totalDiscountPercentage = Number(percentageDifference) + ((100 - Number(percentageDifference)) * Number(totalDiscountPercentage1)) / 100;

    const cashDiscountModifiedData = Number(cashDiscountOrder);
    let totalDiscountcalculationWithoutScheme = Number(
      (Number(totalDiscountPercentage) - Number(cashDiscountOrder)) / (1 - Number(cashDiscountOrder) / 100)
    ).toFixed(2);

    let schemeFree = (Number(selectedItemDetails?.free_qty / (selectedItemDetails?.free_qty + InvQty)) * 100).toFixed(2);
    let totalDiscountcalculation = Number(
      Number(totalDiscountcalculationWithoutScheme) + ((100 - Number(totalDiscountcalculationWithoutScheme)) * Number(schemeFree)) / 100
    ).toFixed(2);
    //=G27/(G27+F27)

    // if (InvDiscountType == "Scheme" && OrdDiscountType == 1) {
    //   modifiedDiscountPercent = discountOrd;
    // } else {
    //   let discountVal = (100 * cashDiscountModifiedData - 100 * cashDiscountInvoice) / (cashDiscountModifiedData - 100)
    //   // modifiedDiscountPercent = OrdDiscountType === 3 ? "0" : discountInv < discountOrd ? discountInv : discountOrd;
    //   let modifiedDataPer = OrdDiscountType === 3 ? "0" : discountInv < discountOrd ? discountInv : discountOrd
    //   modifiedDiscountPercent = Number(
    //     Math.min(modifiedDataPer, Number(discountVal)).toFixed(2)
    //   );
    // }
    if (InvDiscountType == "Scheme" && OrdDiscountType == 1) {
      // M10-15328: selectedItemDetails?.discount_perc is always 0 for a Scheme invoice line
      // (its discount is expressed as free qty, not %), so capping against it always suggested
      // 0%. Suggest the scheme's true percentage equivalent instead: free qty as a share of
      // total units, capped at the order's discount %.
      const totalSchemeUnitsForDiscount = Number(InvQty) + Number(InvFreeQty);
      const equivalentSchemeDiscountPerc =
        totalSchemeUnitsForDiscount > 0 ? (Number(InvFreeQty) / totalSchemeUnitsForDiscount) * 100 : 0;
      modifiedDiscountPercent = Number(
        Math.min(Number(discountOrd), equivalentSchemeDiscountPerc).toFixed(2)
      );
    } else {
      modifiedDiscountPercent = Math.min(Number(totalDiscountcalculation), Number(discountOrd) || 0);
    }
    // M10-15357: when batches are bulk-mapped, the suggested Modified Discount % should also
    // fold in the sibling batches' Scheme free qty — the same combined scheme-to-discount
    // conversion already used for the "Invoice Data" column (combinedInvoiceDiscountPercent),
    // capped at the order's own discount %, instead of only this one row's own figures.
    if (isBulkBatchMapping) {
      modifiedDiscountPercent = Number(
        Math.min(Number(discountOrd) || 0, combinedInvoiceDiscountPercent).toFixed(2)
      );
    }
    let modified_price = selectedItemDetails?.ptr;
    if (OrdDiscountType == 3) {
      if (selectedOrders?.[0]?.fixed_price) {
        // =I15*(100-J15)/100
        const calculationData = Number((Number(selectedItemDetails?.inv_rate) * (100 - Number(discountInv))) / 100).toFixed(2);
        // Replaced-pack line: the order floor is its per-tablet equivalent for the invoice pack.
        modified_price = Math.max(Number(calculationData), packEquivalentPrice(selectedItemDetails, selectedOrders?.[0]) ?? selectedOrders?.[0]?.fixed_price);
      }
    }

    // modifiedFixedPrice = Number(selectedItemDetails?.inv_rate) > Number(fixed_price) ? selectedItemDetails?.inv_rate : fixed_price;

    const newTableData = [
      {
        type: "Quantity",
        invoiceData: selectedItemDetails?.quantity,
        orderedData: String(selectedOrders?.reduce((acc: number, curr: any) => acc + Number(curr?.quantity), 0)),
        // modifiedData: selectedItemDetails?.quantity,

        modifiedData: modifiedQuantity,
        remaining_quantity: remainingQty,
        allowed_quantity: modifiedQuantity,
      },
      {
        type: "Discount %",
        invoiceData: discountInv,
        orderedData: discountOrd,
        modifiedData: modifiedDiscountPercent,
      },
      {
        type: "Cash Discount",
        invoiceData: cashDiscountInvoice,
        orderedData: cashDiscountOrder,
        // modifiedData: selectedItemDetails?.p_cash_discount_perc || 0,
        modifiedData: cashDiscountModifiedData,
        // modifiedData: data?.item_discount,
      },
      {
        type: "Scheme Qty",
        invoiceData: selectedItemDetails?.free_qty,
        orderedData: OrdDiscountType === 2 ? selectedOrders?.[0]?.free_quantity : "0",
        // modifiedData: selectedItemDetails?.free_qty,
        modifiedData: OrdDiscountType === 2 ? modifiedFreeQty : 0,
        allowed_free_qty: OrdDiscountType === 2 ? modifiedFreeQty : 0,
      },
      {
        type: "PTR",
        invoiceData: selectedItemDetails?.ptr,
        // orderedData: selectedOrders?.[0]?.ptr,
        orderedData: selectedItemDetails?.ptr,
        modifiedData: selectedItemDetails?.ptr,
      },
      {
        type: "MRP",
        invoiceData: selectedItemDetails?.inv_mrp,
        orderedData: selectedItemDetails?.inv_mrp,
        // orderedData: selectedOrders?.[0]?.mrp,
        modifiedData: selectedItemDetails?.inv_mrp,
      },
      {
        type: "Price",
        invoiceData: selectedItemDetails?.inv_rate,
        orderedData: fixed_price,
        modifiedData: String(modified_price),
      },
      {
        type: "Calculated Value",
        invoiceData: Number(
          selectedItemDetails?.quantity * selectedItemDetails?.inv_rate * (1 - Number(discountInv) / 100) * (1 - cashDiscountInvoice / 100)
        ).toFixed(2),
        orderedData: "-",
        modifiedData: Number(
          modifiedQuantity * modified_price * (1 - Number(modifiedDiscountPercent) / 100) * (1 - cashDiscountModifiedData / 100)
        ).toFixed(2),
      },
       {
        type: "Calculated Percentage",
        invoiceData: Number(
          (selectedItemDetails?.ptr - selectedItemDetails?.inv_rate) / selectedItemDetails?.ptr * 100
        ).toFixed(2),
        orderedData: "-",
        modifiedData: "-",
      },
    ];

    setTableData(newTableData);
    // M10-15935: selectedProducts is included so that (un)checking a sibling batch of the same item
    // in the "Select" column — after an order has already been chosen for this panel — recomputes
    // the bulk-aware Discount %/Scheme Qty defaults above instead of leaving them stuck at whatever
    // was suggested before the sibling was added.
  }, [selectedOrders, selectedProducts]);

  // M10-15328: Invoice Price can sit below its PTR even when the invoice's own discount_perc
  // is small/zero — that PTR-to-Price gap is an implicit "fixed price" discount not captured by
  // discount_perc alone. Mirrors the totalDiscountcalculation already used above to auto-suggest
  // Modified Discount % on order selection, so validation caps against the same effective value
  // instead of the raw discount_perc.
  const getEffectiveInvoiceDiscountPercent = () => {
    const ptr = Number(selectedItemDetails?.ptr) || 0;
    const invRate = Number(selectedItemDetails?.inv_rate) || 0;
    const cashDiscountInvoice = Number(selectedItemDetails?.p_cash_discount_perc) || 0;
    const cashDiscountOrder = Number(selectedOrders?.[0]?.order?.order_cash_discount_perc) || 0;
    const discountInv = selectedItemDetails?.discount_perc
      ? Number(selectedItemDetails?.discount_perc)
      : selectedItemDetails?.gross_amt > 0
        ? (Number(selectedItemDetails?.discount_amt) / Number(selectedItemDetails?.gross_amt)) * 100
        : 0;

    const percentageDifference = ptr ? Math.abs(((invRate - ptr) / ptr) * 100) : 0;
    const totalDiscountPercentage1 = cashDiscountInvoice + ((100 - cashDiscountInvoice) * discountInv) / 100;
    const totalDiscountPercentage = percentageDifference + ((100 - percentageDifference) * totalDiscountPercentage1) / 100;
    const totalDiscountWithoutScheme =
      cashDiscountOrder < 100 ? (totalDiscountPercentage - cashDiscountOrder) / (1 - cashDiscountOrder / 100) : totalDiscountPercentage;

    const invQty = Number(selectedItemDetails?.unmappedQty) || 0;
    const freeQty = Number(selectedItemDetails?.free_qty) || 0;
    const schemeFree = freeQty + invQty > 0 ? (freeQty / (freeQty + invQty)) * 100 : 0;

    const effectivePercent = totalDiscountWithoutScheme + ((100 - totalDiscountWithoutScheme) * schemeFree) / 100;
    // M10-15595: when the order's own cash discount alone exceeds the invoice's total compounded
    // discount, un-scaling it out here goes negative. Same fix as getCombinedInvoiceDiscountCap —
    // a negative cap isn't a real ceiling below 0, so floor it there instead of blocking a 0%
    // Modified Discount.
    return Number(Math.max(0, effectivePercent).toFixed(2));
  };

  // M10-15357: getEffectiveInvoiceDiscountPercent() above only accounts for this one row's own
  // price/PTR gap + cash discount (its own schemeFree is 0 whenever this row isn't itself a
  // Scheme line). When batches are bulk-mapped, fold the sibling batches' Scheme free qty in too
  // — same compounding used for combinedInvoiceDiscountPercent — so the cap used to validate
  // Modified Discount % reflects the whole selected group, not just the primary row.
  const getCombinedEffectiveInvoiceDiscountPercent = () => {
    const baseEffective = getEffectiveInvoiceDiscountPercent();
    if (!isBulkBatchMapping) return baseEffective;
    return Number((baseEffective + ((100 - baseEffective) * combinedInvoiceSchemeEquivalentPercent) / 100).toFixed(2));
  };

  // M10-15616 Percentages don't simply add — each subsequent discount applies to what's already been
  // discounted, so they cascade the same way totalDiscountPercentage/totalDiscountPercentage1
  // are built above: combine(a, b) = a + (100 - a) * b / 100.
  const compoundPercentages = (a: number, b: number) => a + ((100 - a) * b) / 100;

  // Modified Discount % must never exceed Invoice Data's Discount %, Cash Discount, and
  // Calculated Percentage cascaded together (not simply summed) — the same compounding already
  // used to build totalDiscountPercentage above — compared against Ordered Data's Discount %,
  // whichever total is lower is the actual ceiling the user can enter.
  const getCombinedInvoiceDiscountCap = (currentTableData: any[]) => {
    const invoiceDiscountPercentValue = Number(currentTableData.find((t) => t.type === "Discount %")?.invoiceData) || 0;
    const invoiceCashDiscountValue = Number(currentTableData.find((t) => t.type === "Cash Discount")?.invoiceData) || 0;
    const calculatedPercentageInvoiceData = Number(currentTableData.find((t) => t.type === "Calculated Percentage")?.invoiceData) || 0;
    const discountAndCashCombined = compoundPercentages(invoiceCashDiscountValue, invoiceDiscountPercentValue);
    let combinedCap = compoundPercentages(calculatedPercentageInvoiceData, discountAndCashCombined);
    // M10-15935: the three invoice-side figures above only describe this one row (whichever batch
    // was clicked to open the panel) — a bulk selection's suggested Modified Discount %
    // (combinedInvoiceDiscountPercent) also folds in the sibling batches' Scheme free qty, so this
    // cap must fold the same combinedInvoiceSchemeEquivalentPercent in too (mirroring
    // getCombinedEffectiveInvoiceDiscountPercent below), or it wrongly rejects that legitimately
    // higher combined figure at save time.
    if (isBulkBatchMapping) {
      combinedCap = compoundPercentages(combinedCap, combinedInvoiceSchemeEquivalentPercent);
    }
    // M10-15595: a negative Calculated Percentage (invoice priced slightly above its own PTR)
    // otherwise drags this cap below 0, which would block even a 0% Modified Discount. A negative
    // cap isn't a real ceiling below 0, so floor it there.
    return Math.max(0, combinedCap);
  };

  //On change of modified data
  const handleModifyData = (index: number, value: string) => {
    const updatedTableData = [...tableData];

    const currentType = tableData[index].type;
    const newValue = Number(value);

    //Scheme Validation
    if (currentType === "Scheme Qty") {
      const orderedFreeQuantity = Number(
        remainingQuantity
          ?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]))
          ?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_free_quantity
      );
      const remainingInvoicedFreeQuantity = Number(
        remainingQuantity?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]))?.remaining_invoice_free_quantity
      );

      if (selectedItemDetails?.discount_type == "Scheme" && selectedOrders?.[0]?.price_identifier !== 2) {
        if (remainingInvoicedFreeQuantity < orderedFreeQuantity && newValue > remainingInvoicedFreeQuantity) {
          toast({
            description: `Modified Scheme Qty cannot be greater than remaining invoice free quantity ${remainingInvoicedFreeQuantity}`,
            variant: "destructive",
          });
        }
      }

      if (selectedItemDetails?.discount_type == "Scheme" && selectedOrders?.[0]?.price_identifier !== 1) {
        if (orderedFreeQuantity < remainingInvoicedFreeQuantity && newValue > orderedFreeQuantity) {
          toast({
            description: `Modified Scheme Qty cannot be greater than remaining order free quantity ${orderedFreeQuantity}`,
            variant: "destructive",
          });
        }
      }

      if (isNaN(newValue) || newValue < 0) {
        toast({
          title: "Invalid Scheme Quantity",
          description: "Please enter a valid positive number",
          variant: "destructive",
        });
        return;
      }
    }

    // Quantity validation
    if (currentType === "Quantity") {
      const orderedQuantity = Number(
        remainingQuantity
          ?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]))
          ?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_quantity
      );

      // const remainingInvoicedQuantity = Number(
      //   remainingQuantity?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]))?.remaining_invoice_quantity
      // );

      // M10-15357: capacity-aware combined invoice Quantity across every selected batch of this
      // item — folds a Scheme sibling's free qty into its Quantity contribution for a bulk
      // selection (falls back to the plain single-row value otherwise).
      const remainingInvoicedQuantity = combinedInvoiceUnmappedQuantityCapacity;
      // M10-14122
      const InvDiscountType = selectedItemDetails?.discount_type;
      const OrdDiscountType = selectedOrders?.[0]?.price_identifier;
      // M10-14122

      if (!(InvDiscountType === "Scheme" && OrdDiscountType !== 2) && newValue > remainingInvoicedQuantity) { //M10-14122
        toast({
          description: `Modified quantity cannot be greater than remaining invoice quantity ${remainingInvoicedQuantity}`,
          variant: "destructive",
        });
      }

      if (newValue > orderedQuantity) {
        toast({
          description: `Modified quantity cannot be greater than remaining order quantity ${orderedQuantity}`,
          variant: "destructive",
        });
      }

      if (isNaN(newValue) || newValue < 0) {
        toast({
          title: "Invalid Quantity",
          description: "Please enter a valid positive number",
          variant: "destructive",
        });
        return;
      }
    }

    // Discount % validation
    if (currentType === "Discount %") {
      if (isNaN(newValue) || newValue < 0) {
        toast({
          title: "Invalid Discount %",
          description: "Please enter a valid positive number",
          variant: "destructive",
        });
        return;
      }

      const orderedDiscountType = Number(tableData[index].orderedData);
      // M10-15357: combined invoice Discount % across every selected batch of this item.
      const invoiceDiscountType = Number(getInvoiceDataDisplayValue(tableData[index]));
      // M10-15328: invoiceDiscountType is only a meaningful cap when the invoice line was
      // itself discounted by percent/amount. A Scheme invoice line always has 0 here (its
      // discount was expressed as free qty), so folding it into the cap always blocked any
      // nonzero Modified Discount % for Scheme-origin lines.
      const isInvoicePercentBased = selectedItemDetails?.discount_type === "Discount Percent" || selectedItemDetails?.discount_type === "Discount Amount";
      // M10-15328: when the invoice's Price is a fixed price below its PTR and the matched order
      // is a Discount-on-PTR order, cap against the price-gap-inclusive effective discount
      // instead of the raw discount_perc.
      // Also covers invoices settled via Cash Discount instead of Price/PTR — discount_perc alone
      // is 0 there too, but the cash discount still needs folding into the effective cap.
      const hasFixedPriceComponent = Number(selectedItemDetails?.inv_rate) !== Number(selectedItemDetails?.ptr);
      const hasCashDiscountComponent = (Number(selectedItemDetails?.p_cash_discount_perc) || 0) !== 0;
      const invoiceDiscountCap =
        isInvoicePercentBased && (hasFixedPriceComponent || hasCashDiscountComponent) && selectedOrders?.[0]?.price_identifier === 1
          ? getCombinedEffectiveInvoiceDiscountPercent()
          : invoiceDiscountType;
      const minAllowedDiscount = isInvoicePercentBased ? Math.min(orderedDiscountType, invoiceDiscountCap) : orderedDiscountType;
      // Modified Discount % must also never exceed Invoice Data's Discount %, Cash Discount, and
      // Calculated Percentage cascaded together (not simply summed) — the ordered discount % and
      // this combined invoice total are compared, and whichever is lower is the actual ceiling.
      // Skipped only for a Scheme invoice line — there Discount %/Cash Discount/Calculated
      // Percentage are all structurally 0 (its discount is expressed as free qty, not %/price),
      // so the order's own discount % should govern instead.
      const combinedInvoiceDiscountCap = getCombinedInvoiceDiscountCap(tableData);
      const finalMinAllowedDiscount =
        selectedItemDetails?.discount_type === "Scheme" ? minAllowedDiscount : Math.min(minAllowedDiscount, combinedInvoiceDiscountCap);
      if (newValue > finalMinAllowedDiscount) {
        toast({
          description: `Modified discount % cannot be greater than ${
            finalMinAllowedDiscount === orderedDiscountType ? "ordered" : "combined invoice"
          } discount % ${finalMinAllowedDiscount}`,
          variant: "destructive",
        });
      }
    }

    // Cash Discount validation
    if (currentType === "Cash Discount") {
      if (isNaN(newValue) || newValue < 0) {
        toast({
          title: "Invalid Cash Discount",
          description: "Please enter a valid positive number",
          variant: "destructive",
        });
        return;
      }
    }

    //Price Validation
    if (currentType === "Price") {
      const orderedPrice = Number(tableData[index].orderedData);
      const InvoicePrice = Number(tableData[index].invoiceData);
      if (orderedPrice > InvoicePrice && newValue > orderedPrice) {
        toast({
          description: `Modified Price cannot be greater than ordered price ${orderedPrice}`,
          variant: "destructive",
        });
      }
      if (InvoicePrice > orderedPrice && newValue > InvoicePrice) {
        toast({
          description: `Modified Price cannot be greater than ordered price ${InvoicePrice}`,
          variant: "destructive",
        });
      }
    }

    // M10-14735: Once Discount % or Scheme Qty is modified, Modified Price must be within 5% of Invoice PTR
    if (currentType === "Discount %" || currentType === "Scheme Qty") {
      const priceRow = tableData.find((row) => row.type === "Price");
      const ptrRow = tableData.find((row) => row.type === "PTR");
      const invoicePtr = Number(ptrRow?.invoiceData);
      const modifiedPrice = Number(priceRow?.modifiedData);
      const minAcceptablePrice = invoicePtr * 0.95;

      if (newValue !== 0 && (modifiedPrice > invoicePtr || modifiedPrice < minAcceptablePrice)) {
        toast({
          description: `Modified Price must be within 5% of Invoice PTR (${invoicePtr}), i.e. not less than ${minAcceptablePrice.toFixed(2)}, to modify ${currentType}`,
          variant: "destructive",
        });
        return;
      }
    }

    // Update the current modified value
    updatedTableData[index].modifiedData = value;

    // M10-14793: When invoice discount type is Scheme, Modified Quantity + Modified Scheme Qty
    // cannot exceed the invoice line's remaining (not-yet-mapped) Quantity + Scheme Qty.
    // M10-15287: checked against unmappedQty/unmappedFreeQty (see handleSaveModifiedData for why).
    // M10-15357: when multiple batches of this item are selected, the cap is the group's combined
    // remaining capacity (combinedInvoiceUnmappedQty/FreeQty), not just this one batch's own.
    if (selectedItemDetails?.discount_type === "Scheme" && (currentType === "Quantity" || currentType === "Scheme Qty")) {
      const quantityRow = updatedTableData.find((row) => row.type === "Quantity");
      const schemeQtyRow = updatedTableData.find((row) => row.type === "Scheme Qty");
      const modifiedQtySum = Number(quantityRow?.modifiedData || 0) + Number(schemeQtyRow?.modifiedData || 0);
      const invoiceQtySum = combinedInvoiceUnmappedQty + combinedInvoiceUnmappedFreeQty;
      if (modifiedQtySum > invoiceQtySum) {
        toast({
          description: `Modified Quantity + Scheme Qty (${modifiedQtySum}) cannot be greater than Invoice Quantity + Scheme Qty (${invoiceQtySum})`,
          variant: "destructive",
        });
      }
    }

    // Mutual reset logic
    const discountIndex = tableData.findIndex((item) => item.type === "Discount %");
    const schemeIndex = tableData.findIndex((item) => item.type === "Scheme Qty");

    if (currentType === "Discount %" && schemeIndex !== -1) {
      updatedTableData[schemeIndex].modifiedData = "0";
    }

    if (currentType === "Scheme Qty" && discountIndex !== -1) {
      updatedTableData[discountIndex].modifiedData = "0";
    }
    // 🔽 Recalculate "Calculated Value"
    const quantityRow = updatedTableData.find((item) => item.type === "Quantity");
    const priceRow = updatedTableData.find((item) => item.type === "Price");
    const discountRow = updatedTableData.find((item) => item.type === "Discount %");
    const cashDiscountRow = updatedTableData.find((item) => item.type === "Cash Discount");
    const calculatedValueRowIndex = updatedTableData.findIndex((item) => item.type === "Calculated Value");

    const modifiedQuantity = Number(quantityRow?.modifiedData || 0);
    const modifiedPrice = Number(priceRow?.modifiedData || 0);
    const modifiedDiscount = Number(discountRow?.modifiedData || 0);
    const modifiedCashDiscount = Number(cashDiscountRow?.modifiedData || 0);

    const modifiedCalculatedValue = (
      modifiedQuantity *
      modifiedPrice *
      (1 - modifiedDiscount / 100) *
      (1 - modifiedCashDiscount / 100)
    ).toFixed(2);

    if (calculatedValueRowIndex !== -1) {
      updatedTableData[calculatedValueRowIndex].modifiedData = modifiedCalculatedValue;
    }

    // M10-15595: warn when the Modified Data total works out greater than the Invoice Data
    // total — the same deviation % already shown next to Calculated Value below (positive %
    // there means modified > invoice), surfaced as an alert here too.
    const invoiceCalculatedValue = Number(tableData.find((item) => item.type === "Calculated Value")?.invoiceData) || 0;
    const calculatedValuePercentage =
      Number(modifiedCalculatedValue) > 0 ? ((Number(modifiedCalculatedValue) - invoiceCalculatedValue) / Number(modifiedCalculatedValue)) * 100 : 0;
    if (calculatedValuePercentage > 0) {
      toast({
        description: `Modified Calculated Value (${modifiedCalculatedValue}) cannot be greater than Invoice Calculated Value (${invoiceCalculatedValue})`,
        variant: "destructive",
      });
    }

    setTableData(updatedTableData);
  };

  // Pack change confirmed: the server moves the quantity to a pack-change order (or reprices the
  // untouched line). The line stays unmapped; the user maps it to that order via View.
  const confirmPackChange = async (packPayload: any) => {
    try {
      const response = await postInvoicePackChange({ ...packPayload, confirm: true }, company_code || CompanyCode);
      const result = response?.data?.data;
      for (const streamId of result?.stream_ids ?? []) {
        await withEventCheck(() => undefined, streamId, company_code);
      }
      setSelectedItemDetails(null);
      setTableData(DEFAULT_TABLE_DATA);
      setSelectedOrders([]);
      setSimilarOrders([]);
      setOrderToSelect([]);
      toast({
        title: "Order updated for the supplied pack",
        description: `Click View on this line and map it to order ${result?.order_code}.`,
      });
    } catch (error: any) {
      toast({
        description: `Pack change failed: ${error?.response?.data?.message || error?.message || "unknown error"}`,
        variant: "destructive",
      });
    }
  };

  const saveModifiedData = async (selectedOrders: any[]) => {
    setTcs(Number(invoiceApprovalData?.invoice?.tcs_perc));
    if (!selectedItemDetails) return;

    if (selectedOrders?.length == 0) {
      toast({ description: "Choose an order before submission", variant: "destructive" });
      return;
    }

    // M10-15513: invoice-originated product request. preq_approved === false means this line's rate
    // is still awaiting approval (or was rejected / removed from the request), so it cannot be
    // mapped. Gated on the flag itself, not on the company — the backend only ever sets it for the
    // companies on this flow, and every other invoice carries null.
    if (selectedItemDetails?.preq_approved === false) {
      toast({
        description: "Rate approval is pending for this item. It cannot be mapped until the product request is approved.",
        variant: "destructive",
      });
      return;
    }

    const getRemainingItem = () => {
      return remainingQuantity?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]));
    };

    const showError = (message: string) => {
      toast({ description: message, variant: "destructive" });
      return true;
    };

    //M10-14297: KAM (module_code=4) + INST upload + company 618 — combined qty + scheme qty cap
    const moduleCode = invoiceApprovalData?.module_code;
    const uploadType = invoiceApprovalData?.upload_type;
    if (moduleCode === 4 && uploadType === "INST" && Number(company_code) === 618) {
      const qtyRow = tableData.find((row) => row?.type === "Quantity");
      const schemeRow = tableData.find((row) => row?.type === "Scheme Qty");
      const modifiedQtySum = Number(qtyRow?.modifiedData ?? 0) + Number(schemeRow?.modifiedData ?? 0);
      const orderedQtySum = Number(qtyRow?.orderedData ?? 0) + Number(schemeRow?.orderedData ?? 0);
      if (modifiedQtySum > orderedQtySum) {
        showError(
          `Modified quantity + scheme qty (${modifiedQtySum}) cannot be greater than ordered quantity + free qty (${orderedQtySum})`
        );
        return;
      }
    }
    //M10-14297

    // M10-14793: When invoice discount type is Scheme, Modified Quantity + Modified Scheme Qty
    // cannot exceed the invoice line's remaining (not-yet-mapped) Quantity + Scheme Qty.
    // M10-15287: this must be checked against unmappedQty/unmappedFreeQty, not the static
    // original quantity/free_qty — the latter never shrinks across repeat mappings of the same
    // line, so a line already fully mapped to one order could still pass this check and have
    // its free qty mapped again to a second order.
    // M10-15357: when multiple batches of this item are selected, cap against the group's
    // combined remaining capacity (combinedInvoiceUnmappedQty/FreeQty), not just this one batch.
    // if (selectedItemDetails?.discount_type === "Scheme") {
      const qtyRowGeneral = tableData.find((row) => row?.type === "Quantity");
      const schemeRowGeneral = tableData.find((row) => row?.type === "Scheme Qty");
      const modifiedQtySumGeneral = Number(qtyRowGeneral?.modifiedData ?? 0) + Number(schemeRowGeneral?.modifiedData ?? 0);
      const invoiceQtySumGeneral = combinedInvoiceUnmappedQty + combinedInvoiceUnmappedFreeQty; //M10-15287
      if (modifiedQtySumGeneral > invoiceQtySumGeneral) {
        showError(
          `Modified quantity + scheme qty (${modifiedQtySumGeneral}) cannot be greater than invoice quantity + scheme qty (${invoiceQtySumGeneral})`
        );
        return;
      }
    // }
    //M10-14793


    // Pack (per_strip) change on a fixed-price order with a replace: the server plans a pack-change
    // order (create / top up / reprice in place). The line is never mapped to the old-pack row.
    const packOrder = selectedOrders?.[0];
    const packQuantity = Number(tableData.find((row) => row.type === "Quantity")?.modifiedData) || 0;
    if (
      packOrder?.price_identifier === 3 &&
      packQuantity > 0 &&
      (packOrder?.per_strip == null ||
        selectedItemDetails?.per_strip == null ||
        Number(packOrder?.per_strip) !== Number(selectedItemDetails?.per_strip))
    ) {
      const packPayload = {
        invoice_id: invoiceApprovalData?.invoice?.invoice_id,
        stockist_invoice_attachment_id: Number(stockist_invoice_attachment_id),
        invoice_product_id: selectedItemDetails?.invoice_product_id,
        item_code: packOrder?.replaced_products?.length > 0 ? packOrder?.item_code : selectedItemDetails?.item_code,
        entered_item_code: selectedItemDetails?.item_code,
        order_code: packOrder?.id,
        quantity: packQuantity,
        inv_rate: Number(tableData.find((row) => row.type === "Price")?.modifiedData),
        inv_mrp: Number(tableData.find((row) => row.type === "MRP")?.modifiedData),
        is_replaced: Boolean(selectedItemDetails?.is_replaced || packOrder?.is_replaced || packOrder?.replaced_products?.length),
        // Lines mapped on this screen but not approved yet still sit in the orders' remaining quantity.
        pending_mappings: mappedData.flatMap((m: any) =>
          [m?.order_code].flat().filter(Boolean).map((code: string) => ({ order_code: code, quantity: Number(m?.quantity) || 0 }))
        ),
      };
      let plan: any;
      try {
        plan = (await postInvoicePackChange({ ...packPayload, confirm: false }, company_code || CompanyCode))?.data?.data?.plan;
      } catch (error: any) {
        showError(`Pack check failed: ${error?.response?.data?.message || error?.message || "unknown error"}`);
        return;
      }
      if (plan?.action === "use_existing") {
        showError(plan.message);
        return;
      }
      if (plan && plan.action !== "none") {
        setPackChangeMessage(plan.message);
        perStripContinueRef.current = (confirmed) => {
          if (confirmed) confirmPackChange(packPayload);
        };
        setOpenPerStripModal(true);
        return;
      }
    }

    const hasInvalidQuantity = tableData.some((item) => {
      const modifiedValue = Number(item?.modifiedData);
      // M10-15357: use the combined (Quantity/Scheme Qty/Discount %) invoice value across every
      // selected batch of this item, not just this one batch's own — see getInvoiceDataDisplayValue.
      const invoiceValue = Number(getInvoiceDataDisplayValue(item));
      const orderedValue = Number(item?.orderedData);
      // const allowedQty = Number(item?.allowed_qty);
      // const allowedFreeQty = Number(item?.allowed_free_qty);
      const remainingItem = getRemainingItem();
      const remainingOrderQuantity = remainingItem?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_quantity;
      // const remainingInvoiceQuantity = remainingItem?.remaining_invoice_quantity;
      // M10-15357: capacity-aware — folds a Scheme sibling's free qty into its Quantity
      // contribution for a bulk selection (falls back to the plain single-row value otherwise).
      const remainingInvoiceQuantity = combinedInvoiceUnmappedQuantityCapacity;
      const remainingFreeQuantity = remainingItem?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)
        ?.remaining_free_quantity;
      const InvDiscountType = selectedItemDetails?.discount_type;
      const OrdDiscountType = selectedOrders?.[0]?.price_identifier;

      // Quantity validations
      if (item?.type === "Quantity") {
        if (modifiedValue > remainingOrderQuantity) {
          return showError("Modified quantity cannot be greater than remaining order quantity");
        }
        if (!(InvDiscountType === "Scheme" && OrdDiscountType !== 2) && modifiedValue > remainingInvoiceQuantity) {//M10-14122
          return showError(`Modified quantity cannot be greater than remaining invoice quantity ${remainingInvoiceQuantity}`);
        }
        // M10-15357: capacity-aware cap (combinedInvoiceQuantityCapacity), not the plain
        // combinedInvoiceQuantity used for display — a Scheme sibling's free qty is about to be
        // folded fully into Quantity when saved, so it must count toward this cap too.
        if (!(InvDiscountType === "Scheme" && OrdDiscountType !== 2) && modifiedValue > combinedInvoiceQuantityCapacity) {//M10-14122
          return showError("Quantity cannot be greater than invoiced quantity");
        }
        // if (modifiedValue > allowedQty) {
        //   return showError("Quantity cannot be greater than allowed quantity");
        // }
      }

      // Scheme Qty validations
      if (item?.type === "Scheme Qty") {
        if (
          !(InvDiscountType === "Scheme" && OrdDiscountType === 3) &&
          !(InvDiscountType === "Scheme" && OrdDiscountType === 1) &&
          modifiedValue > remainingFreeQuantity
        ) {
          return showError("Modified free quantity cannot be greater than remaining free quantity");
        }

        // if (!(((InvDiscountType === "Discount Percent" || InvDiscountType === "Discount Amount") && Number(selectedItemDetails?.discount_amt) === 0) && (OrdDiscountType === 2)) &&
        //   !(((InvDiscountType === "Discount Percent" || InvDiscountType === "Discount Amount") && Number(selectedItemDetails?.discount_amt) !== 0) && (OrdDiscountType === 2)) &&
        //   (modifiedValue > invoiceValue)) {
        //   return showError("Scheme Qty cannot be greater than invoiced quantity");
        // }

        if (
          !(InvDiscountType === "Scheme" && OrdDiscountType === 3) &&
          !(InvDiscountType === "Scheme" && OrdDiscountType === 1) &&
          modifiedValue > orderedValue
        ) {
          return showError("Scheme Qty cannot be greater than ordered quantity");
        }
      }

      //   if (modifiedValue > remainingFreeQuantity && OrdDiscountType !== 3 &&
      //     InvDiscountType === "Scheme" &&
      //     OrdDiscountType !== 1
      //   ) {
      //     return showError("Modified free quantity cannot be greater than remaining free quantity");
      //   }

      //   if ((OrdDiscountType !== 3 && InvDiscountType === "Scheme") &&
      //     (OrdDiscountType !== 2 && InvDiscountType !== "Scheme")) {
      //     if (modifiedValue > invoiceValue) {
      //       return showError("Scheme Qty cannot be greater than invoiced quantity");
      //     }
      //   }

      //   if (modifiedValue > orderedValue && OrdDiscountType !== 3 &&
      //     InvDiscountType === "Scheme" &&
      //     OrdDiscountType !== 1
      //   ) {
      //     return showError("Scheme Qty cannot be greater than ordered quantity");
      //   }
      // }

      // Price validations
      if (item?.type === "Price") {
        if (invoiceValue > orderedValue && modifiedValue > invoiceValue) {
          return showError("Price cannot be greater than invoiced price");
        }
        if (orderedValue > invoiceValue && modifiedValue > orderedValue) {
          return showError("Price cannot be greater than order price");
        }
        if (Number(selectedOrders?.[0]?.fixed_price) > modifiedValue && OrdDiscountType === 3) {
          return showError("Price cannot be less than order price");
        }
        if (OrdDiscountType !== 3 && modifiedValue < orderedValue) {
          return showError(`Modified Price (${modifiedValue}) cannot be less than the order price (${orderedValue}) for a non-fixed-price order`);
        }

        // M10-14735: Discount % / Scheme Qty modification requires Modified Price to be within 5% of Invoice PTR
        const discountRow = tableData.find((t) => t.type === "Discount %");
        const schemeRow = tableData.find((t) => t.type === "Scheme Qty");
        const ptrRow = tableData.find((t) => t.type === "PTR");
        const discountModified = Number(discountRow?.modifiedData) || 0;
        const schemeModified = Number(schemeRow?.modifiedData) || 0;
        const invoicePtr = Number(ptrRow?.invoiceData);
        const minAcceptablePrice = invoicePtr * 0.95;
        if ((discountModified !== 0 || schemeModified !== 0) && (modifiedValue > invoicePtr || modifiedValue < minAcceptablePrice)) {
          return showError(`Modified Price must be within 5% of Invoice PTR (${invoicePtr}), i.e. not less than ${minAcceptablePrice.toFixed(2)}, when Discount % or Scheme Qty is modified`);
        }
      }

      // Discount validations
      if (item?.type === "Discount %") {
        if (modifiedValue < 0) {
          return showError("Discount % cannot be negative");
        }
        // M10-15328: invoiceValue (the invoice's Discount % column) is only a meaningful cap
        // when the invoice line itself was discounted by percent/amount. For a Scheme invoice
        // line, invoiceValue is always 0 (its discount was expressed as free qty, not %), so
        // folding it into the cap here always capped Modified Discount % at 0.
        const isInvoicePercentBased = InvDiscountType === "Discount Percent" || InvDiscountType === "Discount Amount";
        // M10-15328: when the invoice's Price is a fixed price below its PTR and the matched order
        // is a Discount-on-PTR order, cap against the price-gap-inclusive effective discount
        // instead of the raw discount_perc.
        // Also covers invoices settled via Cash Discount instead of Price/PTR — discount_perc alone
        // is 0 there too, but the cash discount still needs folding into the effective cap.
        const hasFixedPriceComponent = Number(selectedItemDetails?.inv_rate) !== Number(selectedItemDetails?.ptr);
        const hasCashDiscountComponent = (Number(selectedItemDetails?.p_cash_discount_perc) || 0) !== 0;
        const invoiceDiscountCap =
          isInvoicePercentBased && (hasFixedPriceComponent || hasCashDiscountComponent) && OrdDiscountType === 1
            ? getCombinedEffectiveInvoiceDiscountPercent()
            : invoiceValue;
        const minAllowedDiscount = isInvoicePercentBased ? Math.min(orderedValue, invoiceDiscountCap) : orderedValue;
        // Modified Discount % must also never exceed Invoice Data's Discount %, Cash Discount, and
        // Calculated Percentage cascaded together (not simply summed) — the ordered discount % and
        // this combined invoice total are compared, and whichever is lower is the actual ceiling.
        // Skipped only for a Scheme invoice line — there Discount %/Cash Discount/Calculated
        // Percentage are all structurally 0 (its discount is expressed as free qty, not %/price),
        // so the order's own discount % should govern instead.
        const combinedInvoiceDiscountCap = getCombinedInvoiceDiscountCap(tableData);
        const finalMinAllowedDiscount =
          InvDiscountType === "Scheme" ? minAllowedDiscount : Math.min(minAllowedDiscount, combinedInvoiceDiscountCap);
        if (modifiedValue > finalMinAllowedDiscount) {
          return showError(
            `Discount cannot be greater than ${
              finalMinAllowedDiscount === orderedValue ? "ordered" : "combined invoice"
            } discount % ${finalMinAllowedDiscount}`
          );
        }
      }

      if (item?.type === "Cash Discount") {
        if (modifiedValue < 0) {
          return showError("Cash Discount cannot be negative");
        }
        if (orderedValue < modifiedValue) {
          return showError("Cash Discount cannot be greater");
        }
      }

      return false;
    });

    if (hasInvalidQuantity) {
      return;
    }

    let modifiedDiscountType = "";
    if (selectedOrders?.[0]?.price_identifier === 1) {
      modifiedDiscountType = "Discount Percent"
    } else if (selectedOrders?.[0]?.price_identifier === 2) {
      modifiedDiscountType = "Scheme"
    } else {
      modifiedDiscountType = "Fixed Price";
    }
    // console.log(selectedOrders,"VIJAYA KUMAR")
    // if ((selectedItemDetails?.discount_type == "Scheme", selectedOrders?.[0]?.price_identifier === 1)) {
    //   modifiedDiscountType = "Discount Percent";
    // } else if (
    //   selectedOrders?.[0]?.price_identifier === 2 &&
    //   (selectedItemDetails?.discount_type == "Discount Percent" || selectedItemDetails?.discount_type == "Discount Amount")
    // ) {
    //   modifiedDiscountType = "Scheme";
    // } else if (
    //   Math.abs(Number(selectedItemDetails?.inv_rate) - Number(selectedItemDetails?.ptr)) > 1
    // ) {
    //   modifiedDiscountType = "Fixed Price";
    // } else {
    //   modifiedDiscountType = selectedItemDetails?.discount_type;
    // }

    const orderCodes = selectedOrders?.map((item: any) => item?.id);

    // M10-15034: baseKey must carry the same 4-segment product identity (item code, batch,
    // MRP, Price) as productsData's unique_key, so the mapped-status update below only ever
    // matches the specific priced line that was actually mapped.
    const baseKey = `${selectedItemDetails?.item_code}~${selectedItemDetails?.batch_no}~${selectedItemDetails?.inv_mrp}~${selectedItemDetails?.inv_rate}~${selectedOrders?.[0]?.id}`;
    const existingCount = mappedData.filter((item) => item.unique_key?.startsWith(baseKey)).length;
    const finalUniqueKey = `${baseKey}~${existingCount + 1}`;
    //M10-14297
    const rawModifiedQuantity = Number(tableData.find((item) => item.type === "Quantity")?.modifiedData) || 0;
    const rawModifiedFreeQty = Number(tableData.find((item) => item.type === "Scheme Qty")?.modifiedData) || 0;
    //M10-14155: KAM+INST+company 618 — roll scheme qty into quantity for the final mapped row
    const isKamInstCompany618 =
      invoiceApprovalData?.module_code === 4 &&
      invoiceApprovalData?.upload_type === "INST" &&
      Number(company_code) === 618;
    let modifiedQuantity = isKamInstCompany618 ? rawModifiedQuantity + rawModifiedFreeQty : rawModifiedQuantity;
    const modifiedFreeQty = isKamInstCompany618 ? 0 : rawModifiedFreeQty;
    //M10-14297

    // siblingBatches/isBulkBatchMapping/finalDiscountPerc/siblingModifiedItems are computed at
    // component scope (near getRowId above) so the sibling preview panels below render off the
    // same values this save uses — see that block for the full rationale.
    // M10-15357: when batches are bulk-mapped, Modified Quantity in the panel is the GROUP's
    // combined total (matching the combined "Invoice Data → Quantity" shown above it), not just
    // this row's own share — the sibling batch(es) always ride along at their own full historical
    // quantity on top. So validate the entered total directly against the group's capacity (no
    // extra addition — that was double-counting the siblings), then give this row only its own
    // share of that total (entered total minus what the siblings already account for) so what
    // actually gets saved across the separate line items sums to exactly what was entered.
    if (isBulkBatchMapping) {
      const siblingCapacityTotal = siblingBatches.reduce(
        (sum, p) => sum + Number(p?.unmappedQty ?? p?.quantity ?? 0) + Number(p?.unmappedFreeQty ?? p?.free_qty ?? 0),
        0
      );
      const enteredGroupTotal = modifiedQuantity + modifiedFreeQty;
      if (enteredGroupTotal < siblingCapacityTotal) {
        showError(
          `Modified Quantity + Scheme Qty (${enteredGroupTotal}) must be at least the sibling batches' own quantity (${siblingCapacityTotal}) already included in the combined total`
        );
        return;
      }
      const remainingItem = getRemainingItem();
      const remainingOrderQtyForGroup = remainingItem?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)
        ?.remaining_quantity;
      if (remainingOrderQtyForGroup != null && enteredGroupTotal > remainingOrderQtyForGroup) {
        showError(
          `Combined quantity across selected batches (${enteredGroupTotal}) cannot be greater than remaining order quantity (${remainingOrderQtyForGroup})`
        );
        return;
      }
      modifiedQuantity = modifiedQuantity - siblingCapacityTotal;
    }

    let grossAmount = Number(tableData.find((item) => item.type === "Price")?.modifiedData) * Number(modifiedQuantity);
    // if (
    //   selectedOrders?.[0]?.price_identifier === 3 &&
    //   Number(selectedItemDetails?.discount_perc) === 0 &&
    //   Number(selectedItemDetails?.discount_amt) === 0 &&
    //   Number(selectedItemDetails?.free_qty) === 0 &&
    //   Number(selectedItemDetails?.inv_rate) < Number(selectedItemDetails?.ptr)
    // ) {
    //   console.log("If",Number(tableData.find((item) => item.type === "Price")?.modifiedData) * Number(modifiedQuantity))
    //   grossAmount = Number(tableData.find((item) => item.type === "Price")?.modifiedData) * Number(modifiedQuantity);
    // } else {
    //   console.log(tableData,"00000")
    //   console.log("else",Number(tableData.find((item) => item.type === "PTR")?.modifiedData) * Number(modifiedQuantity))
    //   grossAmount = Number(tableData.find((item) => item.type === "PTR")?.modifiedData) * Number(modifiedQuantity);
    // }

    const useOrderProductIdentity = selectedOrders?.[0]?.replaced_products?.length > 0;  //M10-14198

    const modifiedItem = {
      ...selectedItemDetails,
       //M10-14198
      ...(useOrderProductIdentity && {
        item_code: selectedOrders?.[0]?.item_code,
        item_description: selectedOrders?.[0]?.product_name,
      }),
       //M10-14198
      // Original entered item code always travels alongside item_code (which carries the order
      // product's code when the mapping went through a replaced product) for the per-strip check.
      entered_item_code: selectedItemDetails?.item_code,
      quantity: modifiedQuantity,
      free_qty: modifiedFreeQty,
      discount_perc: finalDiscountPerc,
      discount_type: modifiedDiscountType,
      cash_discount: tableData.find((item) => item.type === "Cash Discount")?.modifiedData,
      ptr: tableData.find((item) => item.type === "PTR")?.modifiedData,
      inv_mrp: tableData.find((item) => item.type === "MRP")?.modifiedData,
      inv_rate: tableData.find((item) => item.type === "Price")?.modifiedData,
      gross_amt: grossAmount,
      fixed_price: modifiedDiscountType === 'Fixed Price' ? tableData.find((item) => item.type === "Price")?.modifiedData : null,
      // selectedOrders?.[0]?.price_identifier === 3 &&
      //   Number(selectedItemDetails?.discount_perc) === 0 &&
      //   Number(selectedItemDetails?.discount_amt) === 0 &&
      //   Number(selectedItemDetails?.free_qty) === 0 &&
      //   Number(selectedItemDetails?.inv_rate) < Number(selectedItemDetails?.ptr)
      //   ? tableData.find((item) => item.type === "Price")?.modifiedData
      //   : (() => {
      //     switch (selectedItemDetails?.discount_type) {
      //       case "Scheme":
      //         return Number(
      //           selectedItemDetails?.ptr -
      //           (selectedItemDetails?.ptr * ((selectedItemDetails?.free_qty / selectedItemDetails?.quantity) * 100)) / 100
      //         );
      //       default:
      //         if (Number(selectedItemDetails?.inv_rate) < Number(selectedItemDetails?.ptr)) {
      //           return tableData.find((item) => item.type === "Price")?.modifiedData
      //         }
      //         return Number(
      //           selectedItemDetails?.ptr -
      //           (selectedItemDetails?.ptr * ((selectedItemDetails?.discount_amt / selectedItemDetails?.gross_amt) * 100)) / 100
      //         );
      //     }
      //   })(),
      invoice_id: invoiceApprovalData?.invoice?.invoice_id,
      company_stockist_code: String(invoiceApprovalData?.company_stockist_code),
      counter_code: invoiceApprovalData?.counter_code,
      order_code: orderCodes,
      p_cash_discount_perc: Number(tableData.find((item) => item.type === "Cash Discount")?.modifiedData),
      unique_key: finalUniqueKey,
    };

    // M10-13377
    const checkLessThanQuantity = tableData.find(item =>
      ["Scheme Qty"].includes(item.type) &&
      Number(item?.modifiedData ?? 0) < Number(item?.invoiceData ?? 0)
    );
    if (selectedOrders?.[0]?.price_identifier === 2 && checkLessThanQuantity && isConfirmScheme) {
      setVerifyData(checkLessThanQuantity);
      setShowVerifyModal(true);
      return;
    }
    // M10-13377

    setProductsData((prev) =>
      prev.map((item) => {
        const modifiedBaseKey = modifiedItem.unique_key?.split("~").slice(0, 4).join("~");

        // Sibling batches are always mapped in full — no partial-quantity branching needed for them.
        const matchedSibling = siblingModifiedItems.find(
          (sibling) => item.unique_key === sibling.unique_key?.split("~").slice(0, 4).join("~")
        );
        if (matchedSibling) {
          return { ...item, mapped: true, merged: true, unmappedQty: 0, unmappedFreeQty: 0, invoice_status: "fully_invoiced" };
        }

        if (item.unique_key !== modifiedBaseKey) return item;
        const InvDiscountType = selectedItemDetails?.discount_type;
        const OrdDiscountType = selectedOrders?.[0]?.price_identifier;

        let status = "not_invoiced";
        let unmappedQty;
        let unmappedFreeQty;

        //Inv -> Discount on PTR && Ord -> Scheme
        if (
          (InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent") &&
          selectedItemDetails?.discount_amt !== 0 &&
          OrdDiscountType == 2
        ) {
          if (modifiedQuantity + modifiedFreeQty === selectedItemDetails?.unmappedQty) {
            status = "fully_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity - modifiedFreeQty;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty;
          } else if (modifiedQuantity + modifiedFreeQty < selectedItemDetails?.unmappedQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity - modifiedFreeQty;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty;
          }
        }

        //Inv -> Fixed Price && Ord -> Scheme
        else if (
          (InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent") &&
          selectedItemDetails?.discount_amt === 0 &&
          OrdDiscountType === 2
        ) {
          if (modifiedQuantity + modifiedFreeQty === selectedItemDetails?.unmappedQty) {
            status = "fully_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity - modifiedFreeQty;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty;
          } else if (modifiedQuantity + modifiedFreeQty < selectedItemDetails?.unmappedQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity - modifiedFreeQty;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty;
          }
        }

        //Inv -> scheme Ord -> Discount on PTR
        else if (InvDiscountType == "Scheme" && OrdDiscountType === 1) {
          // if (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty) {
          //   status = "partially_invoiced";
          //   unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
          //   unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          // }
          // else if (modifiedQuantity === selectedItemDetails?.unmappedQty || modifiedFreeQty === selectedItemDetails?.unmappedFreeQty) {
          //   status = "fully_invoiced";
          //   unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
          //   unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          // }
          if (modifiedQuantity + modifiedFreeQty === selectedItemDetails?.unmappedQty + selectedItemDetails?.unmappedFreeQty) {
            status = "fully_invoiced";
            unmappedQty = 0;
            unmappedFreeQty = 0;
          } else if (modifiedQuantity + modifiedFreeQty < selectedItemDetails?.unmappedQty + selectedItemDetails?.unmappedFreeQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          }
        }

        //Inv -> Fixed Price && Ord -> Discount on PTR
        else if (
          (InvDiscountType == "Discount Amount" || InvDiscountType == "Discount Percent") &&
          selectedItemDetails?.discount_amt == 0 &&
          OrdDiscountType === 1
        ) {
          if (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          } else if (modifiedQuantity === selectedItemDetails?.unmappedQty || modifiedFreeQty === selectedItemDetails?.unmappedFreeQty) {
            status = "fully_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          }
        }

        //Inv -> Scheme && Ord -> Fixed Price
        else if (InvDiscountType == "Scheme" && OrdDiscountType === 3) {
          if (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          } else if (modifiedQuantity === selectedItemDetails?.unmappedQty || modifiedFreeQty === selectedItemDetails?.unmappedFreeQty) {
            status = "fully_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          }
        }

        //Inv -> Discount on PTR && Ord -> Fixed Price
        else if (
          InvDiscountType == "Discount Amount" ||
          (InvDiscountType == "Discount Percent" && selectedItemDetails?.discount_amt !== 0 && OrdDiscountType === 3)
        ) {
          if (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          } else if (modifiedQuantity === selectedItemDetails?.unmappedQty || modifiedFreeQty === selectedItemDetails?.unmappedFreeQty) {
            status = "fully_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          }
        } else {
          if (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty) {
            status = "partially_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          } else if (modifiedQuantity === selectedItemDetails?.unmappedQty || modifiedFreeQty === selectedItemDetails?.unmappedFreeQty) {
            status = "fully_invoiced";
            unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
            unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
          }
        }

        // if (modifiedQuantity == selectedItemDetails?.unmappedQty && modifiedFreeQty == selectedItemDetails?.unmappedFreeQty) {
        //   status = "fully_invoiced";
        // } else if (
        //   (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty)
        // ) {
        //   status = "partially_invoiced";
        // } else if (
        //   (modifiedQuantity + modifiedFreeQty === selectedItemDetails?.unmappedQty)
        // ) {
        //   status = "fully_invoiced";
        // }

        // if (modifiedQuantity == selectedItemDetails?.unmappedQty && modifiedFreeQty == selectedItemDetails?.unmappedFreeQty) {
        //   status = "fully_invoiced";
        // } else if (
        //   (modifiedQuantity < selectedItemDetails?.unmappedQty || modifiedFreeQty < selectedItemDetails?.unmappedFreeQty) &&
        //   selectedOrders?.[0]?.price_identifier !== 2 &&
        //   selectedItemDetails?.discount_type !== "Discount Amount" &&
        //   selectedOrders?.[0]?.price_identifier !== 2 &&
        //   selectedItemDetails?.discount_type !== "Discount Percent"
        // ) {
        //   status = "partially_invoiced";
        // } else if (
        //   (modifiedQuantity + modifiedFreeQty === selectedItemDetails?.unmappedQty &&
        //     selectedOrders?.[0]?.price_identifier === 2 &&
        //     selectedItemDetails?.discount_type === "Discount Amount") ||
        //   (selectedOrders?.[0]?.price_identifier === 2 && selectedItemDetails?.discount_type === "Discount Percent")
        // ) {
        //   status = "fully_invoiced";
        // }

        // if ((selectedItemDetails?.discount_type === "Discount Amount" || selectedItemDetails?.discount_type === "Discount Percent")
        //   && selectedItemDetails?.discount_amt !== 0
        //   && selectedOrders?.[0]?.price_identifier === 2) {
        //   unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity - modifiedFreeQty;
        //   unmappedFreeQty = selectedItemDetails?.unmappedFreeQty;
        // } else {
        //   unmappedQty = selectedItemDetails?.unmappedQty - modifiedQuantity;
        //   unmappedFreeQty = selectedItemDetails?.unmappedFreeQty - modifiedFreeQty;
        // }

        return {
          ...item,
          mapped: true,
          merged: selectedProducts?.length > 0,
          unmappedQty,
          unmappedFreeQty,
          invoice_status: status,
        };
      })
    );

    setMappedData((prev) => [...prev, modifiedItem, ...siblingModifiedItems]);
    setIsMapped(false)  //M10-11117

    // Sibling batches consume the same order's remaining pool — fold their quantities into the
    // same decrement so the group's combined usage is reflected in one update.
    const siblingQtyTotal = siblingModifiedItems.reduce((sum, s) => sum + Number(s.quantity || 0), 0);
    const siblingFreeQtyTotal = siblingModifiedItems.reduce((sum, s) => sum + Number(s.free_qty || 0), 0);
    const totalMappedQuantity = modifiedItem.quantity + siblingQtyTotal;
    const totalMappedFreeQty = modifiedItem.free_qty + siblingFreeQtyTotal;

    // Decrease the remaining quantity of the selected order
    setRemainingQuantity((prev) =>
      prev.map((item) => {
        const modifiedBaseKey = modifiedItem.unique_key?.split("~").slice(0, 4).join("~");
        const isMatchingItem = item.unique_key === modifiedBaseKey?.split("~")[0];

        if (!isMatchingItem) return item;

        return {
          ...item,
          orders: item.orders.map((order: any) => {
            if (order.order_code !== selectedOrders?.[0]?.id) return order;

            const isScheme =
              selectedItemDetails?.discount_type === "Scheme" &&
              (selectedOrders?.[0]?.price_identifier === 1 || selectedOrders?.[0]?.price_identifier === 3);

            return {
              ...order,
              remaining_quantity: isScheme
                ? order.remaining_quantity - totalMappedQuantity - totalMappedFreeQty
                : order.remaining_quantity - totalMappedQuantity,
              remaining_free_quantity: isScheme ? order.remaining_free_quantity : order.remaining_free_quantity - totalMappedFreeQty,
            };
          }),
          remaining_invoice_quantity: item?.remaining_invoice_quantity - totalMappedQuantity,
          remaining_invoice_free_quantity: item?.remaining_invoice_free_quantity - totalMappedFreeQty,
        };
      })
    );

    setSelectedProducts([]);
    setCheckedRows(new Set());
    setSelectedItemDetails(null);
    setTableData(DEFAULT_TABLE_DATA);
    setSelectedOrders([]);
    setSimilarOrders([]);
    setOrderToSelect([]);

    toast({
      title: "Data Mapped Successfully",
      description: "Item has been added to mapped data.",
    });
  };

  const handleReset = (invoiceApprovalData: any) => {
    setSelectedOrders([]);
    const data = invoiceApprovalData?.invoice?.invoiceProducts?.map((item: any) => ({
      ...item,
      unmappedQty: item?.quantity,
      unmappedFreeQty: item?.free_qty,
      // M10-15034: keep in sync with the unique_key built in fetchInvoiceDetails
      unique_key: `${item?.item_code}~${item?.batch_no}~${item?.inv_mrp}~${item?.inv_rate}`,
    }));
    setProductsData(data);
    setRemainingQuantity([]);
    setMappedData([]);
    setTableData(DEFAULT_TABLE_DATA);
    setSelectedItemDetails(null);
    setIsMapped(true) //M10-11117
    toast({
      title: "Data Reset Successfully",
      description: "All data has been reset.",
    });
  };

  const isRequestInProgress = useRef(false);

  const approveInvoice = async () => {
    if (isRequestInProgress.current) return;
    isRequestInProgress.current = true;

    await withEventCheck(() => { }, `invoice_${invoiceApprovalData?.invoice?.invoice_id}`,invoiceApprovalData?.company_code); //M10-12758
    const invoiceActionAllowedResponse = await getInvoiceActionAllowed(
      invoiceApprovalData?.invoice?.invoice_id,
      invoiceApprovalData?.stockist_invoice_attachment_id,
      "Approval",
      invoiceApprovalData?.company_code
    );
    if (!invoiceActionAllowedResponse?.data?.data?.allowed) {
      toast({ description: invoiceActionAllowedResponse?.data?.data?.message, variant: "destructive" });
      return;
    }
    if (mappedData.length == 0) {
      toast({ description: "Please add products", variant: "default" });
      return;
    }

    // M10-15513: invoice-originated product request. Lines still awaiting rate approval are simply
    // left out of the approval — the rest of the invoice approves normally — so the only thing to
    // stop here is a mapping that already slipped one in. Matched by invoice_product_id so a line
    // that was mapped before its request was rejected is caught too.
    const preqBlockedProductIds = new Set(
      (productsData || []).filter((item: any) => item?.preq_approved === false).map((item: any) => item?.invoice_product_id)
    );
    if (preqBlockedProductIds.size > 0) {
      const blockedMapped = mappedData.filter((item: any) => preqBlockedProductIds.has(item?.invoice_product_id));
      if (blockedMapped.length > 0) {
        toast({
          description: `Rate approval is pending for item(s) ${[...new Set(blockedMapped.map((item: any) => item?.item_code))].join(", ")}. Remove them from the mapping before approving.`,
          variant: "destructive",
        });
        return;
      }
    }

    setIsApproving(true);

    const currentDate = new Date(invoiceApprovalData?.invoice?.new_invoice_date);
    const invoiceAccYear = getFinancialYear(currentDate);

    const payloadToValidateInV1 = {
      cmpstockistcode: invoiceApprovalData?.company_stockist_code,
      invoicenumber_searchcolumn: invoiceApprovalData?.invoice?.invoice_number || "",
      invoice_accyear: invoiceAccYear,
      company_code: invoiceApprovalData?.company_code,
    };

    const response = await getInvoiceChangeValidationV1(payloadToValidateInV1);
    if (response?.data?.success !== "success") {
      toast({ description: response?.data?.message, variant: "destructive" });
      setIsApproving(false);
      return;
    }
    // const payload = {
    //   data: mappedData,
    //   primary_key: invoiceApprovalData?.invoice?.invoice_id,
    //   event_type: "INVOICE_PRODUCT_EDIT",
    // };

    try {
      // const invoiceApproveResponse = await editInvoiceProduct(payload);
      // if (invoiceApproveResponse) {
      const invoiceEditPayload = {
        data: {
          invoice_id: invoiceApprovalData?.invoice?.invoice_id,
          stockist_invoice_attachment_id: Number(stockist_invoice_attachment_id),
          cash_discount_perc: Number(invoiceApprovalData?.invoice?.cash_discount_perc),
          cash_discount: String(calculateTotalCashDiscount()),
          net_amount: String(invoiceApprovalData?.invoice?.net_amount),
          tcs_perc: Number(tcs),
          tcs_amt: ((calculateSubtotal() - (calculateSubtotal() * calculateTotalCashDiscount()) / 100 + calculateTotalGst()) * tcs) / 100,
          gst_amount: calculateTotalGst()?.toFixed(2),
          gross_amount: calculateSubtotal()?.toFixed(2),
          approval: true,
          // extra payload for backend versioining
          stockist_id: invoiceApprovalData?.stockist_id,
          invoice_number: invoiceApprovalData?.invoice?.invoice_number,
          // invoice header details sending for backend versioning
          u_code: invoiceApprovalData?.invoice?.u_code,
          new_invoice_date: invoiceApprovalData?.invoice?.new_invoice_date,
          // ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
          e_inv_ref_type: invoiceApprovalData?.invoice?.e_inv_ref_type,
          irn: invoiceApprovalData?.invoice?.irn,
          gst_validated: invoiceApprovalData?.invoice?.gst_validated,
          dl_validated: invoiceApprovalData?.invoice?.dl_validated,
          mci_validated: invoiceApprovalData?.invoice?.mci_validated,
          counter_gst_number: invoiceApprovalData?.counter_gst_number || "",
          counter_dl_number: invoiceApprovalData?.counter_dl_number || "",
          counter_mci_number: invoiceApprovalData?.counter_mci_number || "",
          invoice_num_modified: false,
          counter_data_validation: false,
          invoiceProduct: mappedData?.map(item => ({ ...item, ...(hasPermissionInvoicePreDate && { temp_invoice_date: tempDate }) })),  //M10-15191
          approved_item_count: mappedData?.length
        },
        primary_key: invoiceApprovalData?.invoice?.invoice_id,
        event_type: "INVOICE_EDIT",
      };

      const invoiceEditResponse = await editInvoice(invoiceEditPayload, company_code);

      const invoiceStatusUpdateResponse = await withEventCheck(
        () => {
          return getInvoiceDetails(stockist_invoice_attachment_id as string, false, company_code || CompanyCode);
        },
        invoiceEditResponse?.data?.data?.products?.at(-1)?.eventStreamCreated?.streamId,
        company_code  //M10-12758
      );
      console.log(invoiceStatusUpdateResponse);
      toast({ description: "Invoice approved successfully", variant: "default" });
      navigate("/transactions/invoice/1");
    } catch (error: any) {
      console.log(error);
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    } finally {
      isRequestInProgress.current = false;
      setIsApproving(false);
    }
  };
  const handleApproveInvoice = useDebounceLeading(approveInvoice, 1000);

  const inputFieldValidationHandler = (item: any) => {
    const modifiedValue = Number(item?.modifiedData);

    const priceIdentifier = selectedOrders?.[0]?.price_identifier;
    const discountType = selectedItemDetails?.discount_type;

    // M10-14793: When invoice discount type is Scheme, Modified Quantity + Modified Scheme Qty
    // cannot exceed Invoice Quantity + Invoice Scheme Qty
    // M10-15357: combined across every selected batch of this item, not just this one batch's own.
    if (discountType === "Scheme" && (item?.type === "Quantity" || item?.type === "Scheme Qty")) {
      const quantityRow = tableData.find((row) => row?.type === "Quantity");
      const schemeQtyRow = tableData.find((row) => row?.type === "Scheme Qty");
      const modifiedQtySum = Number(quantityRow?.modifiedData || 0) + Number(schemeQtyRow?.modifiedData || 0);
      const invoiceQtySum = combinedInvoiceQuantity + combinedInvoiceSchemeQty;
      if (modifiedQtySum > invoiceQtySum) {
        return true;
      }
    }

    if (item?.type === "Quantity") {
      // M10-15357: capacity-aware combined invoice Quantity across every selected batch of this
      // item — folds a Scheme sibling's free qty into its Quantity contribution for a bulk
      // selection (falls back to the plain single-row value otherwise).
      const invoiceValue = combinedInvoiceQuantityCapacity;
      const remainingItem = remainingQuantity?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]));
      const remainingOrderQuantity = remainingItem?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_quantity;
      // const remainingInvoiceQuantity = remainingItem?.remaining_invoice_quantity;
      const remainingInvoiceQuantity = combinedInvoiceUnmappedQuantityCapacity;

      //Inv -> Scheme && Ord -> Discount on PTR
      if (discountType === "Scheme" && Number(modifiedValue) > Number(remainingOrderQuantity) && priceIdentifier === 1) {
        return true;
      }

      if (
        !(discountType === "Scheme" && priceIdentifier === 1) &&
        (Number(modifiedValue) > Number(invoiceValue) ||
          Number(modifiedValue) > Number(remainingOrderQuantity) ||
          Number(modifiedValue) > Number(remainingInvoiceQuantity))
      ) {
        return true;
      }
    } else if (item?.type === "Discount %") {
      const orderedValue = Number(item?.orderedData);
      // Modified Discount % must also never exceed Invoice Data's Discount %, Cash Discount, and
      // Calculated Percentage cascaded together (not simply summed) — the ordered discount % and
      // this combined invoice total are compared, and whichever is lower is the actual ceiling.
      // Skipped only for a Scheme invoice line — there Discount %/Cash Discount/Calculated
      // Percentage are all structurally 0 (its discount is expressed as free qty, not %/price),
      // so the order's own discount % should govern instead.
      const combinedInvoiceDiscountCap = getCombinedInvoiceDiscountCap(tableData);
      const cap = discountType === "Scheme" ? orderedValue : Math.min(orderedValue, combinedInvoiceDiscountCap);
      if (modifiedValue < 0 || modifiedValue > cap) {
        return true;
      }
    } else if (item?.type === "Scheme Qty") {
      // const invoiceValue = Number(item?.invoiceData);
      // const remainingItem = remainingQuantity?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]));
      // const remainingFreeQuantity = remainingItem?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)
      // ?.remaining_free_quantity;
      // const remainingInvoiceFreeQuantity = remainingItem?.remaining_invoice_free_quantity;
      const allowedFreeQty = item?.allowed_free_qty;
    
      
      if (item?.allowed_free_qty > modifiedValue) {
        return true;
      }

      //Inv -> Discount on PTR && Ord -> Scheme
      if (
        (discountType === "Discount Percent" || discountType === "Discount Amount") &&
        Number(selectedItemDetails?.discount_amt) !== 0 &&
        modifiedValue > allowedFreeQty &&
        priceIdentifier === 2
      ) {
        return true;
      }

      //Inv -> Fixed && Ord -> Scheme
      if (
        (discountType === "Discount Percent" || discountType === "Discount Amount") &&
        Number(selectedItemDetails?.discount_amt) == 0 &&
        modifiedValue > allowedFreeQty &&
        priceIdentifier === 2
      ) {
        return true;
      }

      //Inv -> Scheme && Ord -> Discount on PTR
      if (discountType === "Scheme" && modifiedValue > allowedFreeQty && priceIdentifier === 1) {
        return true;
      }

      //Inv -> Fixed && Ord -> Discount on PTR
      if (
        (discountType === "Discount Percent" || discountType === "Discount Amount") &&
        Number(selectedItemDetails?.discount_amt) == 0 &&
        modifiedValue > allowedFreeQty &&
        priceIdentifier === 1
      ) {
        return true;
      }

      //Inv -> Scheme && Ord -> Fixed Price
      if (discountType === "Scheme" && modifiedValue > allowedFreeQty && priceIdentifier === 3) {
        return true;
      }

      //Inv -> Discount on PTR && Ord -> Scheme
      if (
        (discountType === "Discount Percent" || discountType === "Discount Amount") &&
        Number(selectedItemDetails?.discount_amt) !== 0 &&
        modifiedValue > allowedFreeQty &&
        priceIdentifier === 3
      ) {
        return true;
      }

      // if ((!(discountType === "Scheme" && priceIdentifier === 3)) &&
      //   (discountType !== "Discount Percent" && discountType !== "Discount Amount") &&
      //   (!(discountType === "Scheme" && priceIdentifier === 1)) &&
      //   (modifiedValue > invoiceValue || modifiedValue > remainingFreeQuantity || modifiedValue > remainingInvoiceFreeQuantity)
      // ) {
      //   return true;
      // }
    } else if (item?.type === "Price") {
      const invoiceValue = Number(item?.invoiceData);
      const orderedValue = Number(item?.orderedData);

      if ((packEquivalentPrice(selectedItemDetails, selectedOrders?.[0]) ?? Number(selectedOrders?.[0]?.fixed_price)) > modifiedValue && priceIdentifier === 3) {
        return true;
      }
      if (invoiceValue > orderedValue) {
        if (modifiedValue > invoiceValue) {
          return true;
        }
      } else {
        if (modifiedValue > orderedValue) {
          return true;
        }
      }

      // M10-14735: Discount % / Scheme Qty modification requires Modified Price to be within 5% of Invoice PTR
      const discountRow = tableData.find((t) => t.type === "Discount %");
      const schemeRow = tableData.find((t) => t.type === "Scheme Qty");
      const ptrRow = tableData.find((t) => t.type === "PTR");
      const discountModified = Number(discountRow?.modifiedData) || 0;
      const schemeModified = Number(schemeRow?.modifiedData) || 0;
      const invoicePtr = Number(ptrRow?.invoiceData);
      const minAcceptablePrice = invoicePtr * 0.95;
      if ((discountModified !== 0 || schemeModified !== 0) && (modifiedValue > invoicePtr || modifiedValue < minAcceptablePrice)) {
        return true;
      }
    } else if (item?.type === "Cash Discount") {
      const orderDiscount = Number(selectedOrders?.[0]?.order?.order_cash_discount_perc);
      const modifyDiscount = Number(item?.modifiedData);
      if (modifyDiscount < 0 || modifyDiscount > orderDiscount) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    fetchInvoiceDetails();
  }, []);
  //M10-15287
  useEffect(() => {
    if (!invoiceApprovalData?.invoice?.invoice_id) return;
    withEventCheck(
      () => {},
      `invoice_${invoiceApprovalData.invoice.invoice_id}`,
      invoiceApprovalData?.company_code
    ).catch(() => {});
  }, [invoiceApprovalData?.invoice?.invoice_id, invoiceApprovalData?.company_code, withEventCheck]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }
  // M10-12438
  const isAnyPoGenerated =
    invoiceApprovalData?.invoice?.invoiceProducts?.some(
      (product: any) =>
        product?.orderProductMappings?.some(
          (mapping: any) => mapping?.is_po_generated === true
        )
    ) ?? false;

  const handleRemove = async (selectedIds: any) => {
    try {
      const poIds = selectedIds
        .map((item: any) => item?.po_item?.po_id)
        .filter((id: number | undefined) => id !== undefined);

      const uniquePoIds = new Set(poIds);

      if (uniquePoIds.size > 1) {
        toast({ description: 'Selected items must belong to the same Purchase Order', variant: "destructive" })
        return
      }
      const poCompanyCode = invoiceApprovalData?.company_code || CompanyCode;
      const body = {
        data: {
          invoice_product_order_product_id: selectedIds.map(
            (item: any) => item.invoice_product_order_product_id
          ),
          type:"removePoByIpop",
          invoice_id: invoiceApprovalData?.invoice?.invoice_id,
          po_id: selectedIds?.[0]?.po_item?.po_id,
          Invoice_Ucode: invoiceApprovalData?.invoice?.uid,
          po_number:selectedIds?.[0]?.po_item?.purchaseOrder?.po_number,// M10-13906
          company_code: poCompanyCode // M10-13906
        },
        primary_key: selectedIds?.[0]?.po_item?.po_id,
        event_type: 'PO_REMOVE',
      };

      const removePo = await removePoApi(body, poCompanyCode)
      console.log(body, "removePo", removePo)
      toast({ title: "Success", description: "POs removed successfully" });
      // Refresh data
      // M10-13676
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || error?.message ||
        "Something went wrong";

      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    }
    // M10-13676
  };
  // M10-12438

  const handleFormSubmit = async (payload: any): Promise<boolean> => {
    setLoading(true);
    try {
      const finalPayload = {
        ...payload,
        reference_number: `Approval-${payload.reference_number}`,
      };
      
      const res = await addFeedback(finalPayload);

      if (res?.status === 200) {
        toast({ description: "Feedback submitted successfully" });
        return true;
      } else {
        toast({
          variant: "destructive",
          description: res?.data?.message || "Failed to submit feedback",
        });
        return false;
      }
    } catch (err: any) {
      toast({
        variant: "destructive",
        description: err?.message || "Failed to submit feedback",
      });
      return false;
    } finally {
      setIsFeedbackModalOpen(false);
      setLoading(false);
    }
  };
  // M10-13191
  const unknownCalculation = () => {
    const unknownTotal = productsData?.filter((item) => item.is_item_unknown)?.reduce((sum, item) => sum + Number(item.net_amt || 0), 0);
    return unknownTotal
  }
  // M10-13191

  return (
    <InvoiceLayout>
      <Fragment>
        <Transition
          as={Fragment}
          show={isRemarksShown}
          enter="transition transition ease-in-out duration-200 transform"
          enterFrom="translate-x-full"
          enterTo="translate-x-0"
          leave="transition  ease-in-out duration-200 transform"
          leaveFrom="translate-x-0"
          leaveTo="translate-x-full"
        >
          <div className="fixed right-0 inset-0 top-0 z-[500]">
            <InvoiceRemarks invoiceApprovalData={invoiceApprovalData} invoice_id={Number(invoiceApprovalData?.invoice?.invoice_id)} ref={ref} />
          </div>
        </Transition>
      </Fragment>
      <div className="mx-auto mt-10">
        <div className="flex flex-col px-[3.75rem] mt-6  pb-12 shadow-md border-b-[1px] border-b-[#E9E9E9]">
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div
                className="flex items-center cursor-pointer font-semibold px-0 py-2 text-lg text-[#7F56D9]"
                onClick={() => navigate("/transactions/invoice/1")}
              >
                <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
                Back to Invoices
              </div>
              <h1 className="text-[#49484C] font-bold text-[2rem]">Invoice Approval</h1>
            </div>
          </div>
          {/* //M10-11601 */}
          <div className="absolute right-4 flex flex-row gap-3 items-end mt-24">
            <div
              onClick={() => setIsFeedbackModalOpen(true)}
              className="p-2 bg-white cursor-pointer"
            >
              <MessageSquareText className="text-gray-500 h-6 w-6" />
            </div>

            {/* Versioning */}
            <div
              onClick={() => setVersioningModal((prev) => !prev)}
            >
              <img src={Book} alt="Version" className="h-10 w-14 " />
            </div>

            {/* Remarks */}
            {viewRemarks && (
              <div
                onClick={() => setIsRemarksShown(true)}
                className="p-2 bg-white cursor-pointer"
              >
                <MessageCircle className="text-gray-500 h-6 w-6" />
              </div>
            )}
          </div>
        </div>
        {/* M10-15287 */}
        {isInvoiceEventBlocked && (
          <div
            className="py-0.5"
            style={{
              width: "100%",
              backgroundColor: "rgba(117, 80, 250, 0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              style={{
                color: "#7450FA",
                fontSize: "16px",
                fontWeight: "bold",
                textShadow: "1px 1px 2px #FFFFFF",
                padding: "6px 0",
              }}
            >
              We regret to inform you, The event has been "blocked" due to too many rigorous events in Queue.
            </p>
          </div>
        )}

        <div className="p-5 mt-10 mx-[3.75rem] rounded-xl border border-[#d0d0d0] shadow-sm">
          <header className="w-full">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                {invoiceApprovalData?.is_prioritised && (
                  <img src={star} className="p-1 mr-2 w-8 h-8 rounded-lg border border-[#d0d0d0] shadow-md" alt="star" />
                )}
                {!invoiceApprovalData?.is_prioritised && (
                  <img src={starEmpty} className="p-1 mr-2 w-8 h-8 rounded-lg border border-[#d0d0d0] shadow-md" alt="star" />
                )}
                <h1 className={"font-semibold text-lg text-[1.5rem] mr-4"}>
                  <span className="text-gray-400 text-[1.2rem]">Invoice# </span>
                  {invoiceApprovalData?.invoice?.invoice_number}
                </h1>
                <h1
                  className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
                  style={{
                    backgroundColor: invoiceApprovalData?.fileStatusHdr?.color_code,
                    color: invoiceApprovalData?.fileStatusHdr?.text_color_code,
                  }}
                >
                  {invoiceApprovalData?.fileStatusHdr?.fuid_status_desc}
                  <img className="w-3 h-3 ml-1 cursor-pointer" src={downArrow} alt="down-arrow" />
                </h1>
                {/* M10-16200: category 1 e-invoice status */}
                {invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 8 && invoiceApprovalData?.cat1_einvoice_status && (
                  <p className={`ml-4 text-sm font-semibold border rounded-full px-2 py-0.5 ${cat1EinvoiceStatusColor[invoiceApprovalData.cat1_einvoice_status?.toLowerCase()] || "text-[#055160] bg-[#E0F2FE]"}`}>
                    Cat-1 Verification : <span className="capitalize">{invoiceApprovalData.cat1_einvoice_status}</span>
                  </p>
                )}
                {invoiceApprovalData?.po_stockist_ack_status === "PENDING" && (
                  <p className="ml-4 text-[#92400E] text-sm font-semibold border bg-[#FEF3C7] rounded-full px-2 py-0.5">Stockist Ack: Pending</p>
                )}
                {invoiceApprovalData?.po_stockist_ack_status === "ACCEPTED" && (
                  <p className="ml-4 text-[#166534] text-sm font-semibold border bg-[#DCFCE7] rounded-full px-2 py-0.5">Stockist Ack: Accepted</p>
                )}
              </div>
              <div className="flex gap-x-1.5">
                <Button
                  onClick={() => {
                    if (!invoiceApprovalData?.file_path) {
                      toast({ description: "Invoice not found", variant: "destructive" });
                      return;
                    }
                    downloadInvoice(invoiceApprovalData?.file_path, company_code).then((res: any) => {
                      if (res?.data?.success && res?.data?.data) {
                        window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                        //M10-15262
                        dispatch(invoiceActions.setInvoiceVerification({
                          invoiceId: invoiceApprovalData?.invoice?.invoice_id,
                          isDownloaded: true,
                        }));
                      } else {
                        console.error("Failed to download the invoice.");
                      }
                    });
                  }}
                  className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                >
                  <img src={Download} className="w-4 h-4 mr-1" alt="save-file" />
                  Invoice{" "}
                </Button>
                {/* M10-15105 */}
                <Button
                  onClick={() => {
                    if (!invoiceApprovalData?.textract_file_path) {
                      toast({ description: "MV Lens Output not found", variant: "destructive" });
                      return;
                    }
                    downloadInvoice(invoiceApprovalData?.textract_file_path, company_code).then((res: any) => {
                      if (res?.data?.success && res?.data?.data) {
                        window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                      } else {
                        console.error("Failed to download the MV Lens Output.");
                      }
                    });
                  }}
                  className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                >
                  <img src={Download} className="w-4 h-4 mr-1" alt="textract-file" />
                  MV Lens Output{" "}
                </Button>
                {/* M10-15105 */}
                <Button
                  onClick={() => {
                    if (!invoiceApprovalData?.einv_attachment_path) {
                      toast({ description: "E-Invoice not found", variant: "destructive" });
                      return;
                    }
                    downloadInvoice(invoiceApprovalData?.einv_attachment_path, company_code).then((res: any) => {
                      if (res?.data?.success && res?.data?.data) {
                        window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                      } else {
                        console.error("Failed to download the E-Invoice.");
                      }
                    });
                  }}
                  className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                >
                  <img src={Download} className="w-4 h-4 mr-1" alt="send" />
                  E-Invoice{" "}
                </Button>
                {([5, 6, 24].includes(invoiceApprovalData?.fileStatusHdr?.fuid_status_id)) && (
                  <Button
                    disabled={invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 8}
                    className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                    onClick={() => setRevertInvoiceOpen(true)}
                    module={fineGrainedPermissionsKeys.INVOICE.REVERTINVOICE.module}
                    action={fineGrainedPermissionsKeys.INVOICE.REVERTINVOICE.action}
                  >
                    Revert Invoice
                  </Button>
                )}
                {[8, 15].includes(invoiceApprovalData?.fileStatusHdr?.fuid_status_id) && (
                  <Button
                    className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                    onClick={() => setRecallInvoiceOpen(true)}
                    module={fineGrainedPermissionsKeys.INVOICE.REMOVEINVOICE.module}
                    action={fineGrainedPermissionsKeys.INVOICE.REMOVEINVOICE.action}
                  >
                    Remove Invoice
                  </Button>
                )}
                {/* M10-12438 */}
                {[8, 15].includes(invoiceApprovalData?.fileStatusHdr?.fuid_status_id) && isAnyPoGenerated &&
                  [
                    "d1c3cdfa-a0e1-70ab-0fdf-93c2899a7efb", //Vishnu
                    "21e33dfa-20c1-707e-fbde-d015a307d71b", //Surya
                    "91839d1a-10b1-70d1-db8a-7f99df97d59a", //Yousuf
                    "3e354c07-8918-4963-89f0-093d582f84da"  //Arun
                  ].some(id => idTokenDetails?.sub?.includes(id)) && (
                    <Button
                      className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                      onClick={() => setRemovePOmodel(true)}
                      module={fineGrainedPermissionsKeys.INVOICE.REMOVEPO.module}
                      action={fineGrainedPermissionsKeys.INVOICE.REMOVEPO.action}
                    >
                      Remove PO
                    </Button>
                  )}
                {/* M10-12438 */}
                {/* <Button className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600">
                  <img src={cross} className="w-4 h-4 mr-1 invert" alt="cross" />
                  Clear{" "}
                </Button> */}
              </div>
            </div>
          </header>
          {VersioningModal && (
            <div ref={outSideClickRef}>
              <VersioningCrate type="Invoice" invoiceId={invoiceApprovalData?.invoice?.invoice_id} stockistInvAttachmentId={invoiceApprovalData?.stockist_invoice_attachment_id} />
            </div>
          )}
          <ul className="mt-5">
            <li className="my-5 mb-10 rounded-lg">
              <InvoiceDetailCard
                isExpandedInitial={true}
                isExpandable={false}
                status={invoiceApprovalData?.fileStatusHdr?.fuid_status_desc}
                checkDataType={false}
                data={getInvoiceDetailsInfo(invoiceApprovalData)}
                viewDetails={false}
                invoiceData={invoiceApprovalData}
                showHeader={false}
                fetchInvoiceDetails={fetchInvoiceDetails}
                tab={1}
                isMapped={isMapped} //M10-11117
              />
            </li>
          </ul>

          {
            <div className="px-4 mt-10 mb-10 rounded-lg">
              <div className="flex items-center gap-x-4 pb-5 border-b-2 border-gray-200">
                <p className="mb-2 text-lg font-semibold">Invoice Details</p>
                {invoiceApprovalData?.orderCodes?.length > 0 && (
                  <p className="text-sm text-gray-500 border border-gray-300 rounded-lg p-1 px-2">
                    Order Code: {invoiceApprovalData?.orderCodes?.map((code: any) => code?.order_code).join(", ")}
                  </p>
                )}
                  {invoiceApprovalData?.poid_ref_number && (
                  <p className="text-sm text-gray-500 border border-gray-300 rounded-lg p-1 px-2">
                    Invoice PO Ref No: {invoiceApprovalData?.poid_ref_number}
                  </p>
                )}
              </div>

              <table className="min-w-full mt-5 border border-gray-200">
                <thead className="w-full bg-gray-100">
                  <tr>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">S.No</th> {/* M10-9670 */}
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Select</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Product Type</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Item code</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Item description</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. MRP</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. PTR</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Price</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. Qty.</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Gross Amt.</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. Scheme</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Discount %</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Discount Amount</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Scheme Qty.</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">CD %</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">GST % </th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Batch</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Order Map</th>
                    <th className="px-1 py-2 text-sm text-left text-gray-600">Mapped</th>
                  </tr>
                </thead>
                <tbody>
                  {[...(productsData || [])]?.sort((a: any, b: any) => (a?.textractProduct?.stockistfile_detail_code || 0) - (b?.textractProduct?.stockistfile_detail_code || 0))
                    ?.map((item: any, index: any) => {
                      const isCurrentlyEditing =
                        !!selectedItemDetails && item?.unique_key === selectedItemDetails?.unique_key;
                      return (
                      <tr
                        key={index}
                        className={`text-sm ${
                          isCurrentlyEditing
                            ? "bg-[#EDE7FF] border-l-4 border-l-[#8051FF]"
                            : item?.is_item_unknown
                            ? "bg-[#F0F7FF]"
                            : item?.preq_approved === false
                            ? "bg-[#FFF4E5]" // M10-15513: rate approval still pending — not mappable
                            : index % 2 === 0
                            ? "bg-gray-50"
                            : ""
                        }`}
                      >
                        <td className="px-1 py-2 border-t">{index + 1}</td> {/* M10-9670 */}
                        {!item?.is_item_unknown && productsData?.filter((p) => p.item_code === item.item_code).length > 1 ? (
                          <td className="px-4 py-2 border-t">
                            <Checkbox
                              checked={checkedRows.has(getRowId(item, index))}
                              disabled={selectedOrders?.[0]?.price_identifier === 2}
                              onChange={(e: any) => handleCheckboxChange(e, item, index)}
                            />
                          </td>
                        ) : (
                          <td className="px-4 py-2 border-t"></td>
                        )}
                        <td className="px-1 py-2 border-t">
                          {item?.is_item_unknown ? (
                            "UO"
                          ) : item?.preq_approved === false ? (
                            // M10-15513: rate approval pending on the invoice-originated product request
                            <span title="Rate approval pending">CP/OP*</span>
                          ) : (
                            "CP/OP"
                          )}
                        </td>
                        {/* M10-14632 */}
                        <td className="px-1 py-2 border-t">
                          {item?.is_item_unknown ? (
                            item?.item_code
                          ) : (
                            <span
                              className="text-[#7F56D9] cursor-pointer hover:underline"
                              onClick={async () => {
                                try {
                                  const res = await searchProduct({
                                    search: item?.item_code,
                                    page: 1,
                                    perPage: 10,
                                    company_code: invoiceApprovalData?.company_code,
                                  });
                                  const matched = res?.data?.data?.find(
                                    (p: any) => p.item_code === item?.item_code
                                  );
                                  if (matched?.company_productcode) {
                                    window.sessionStorage.setItem("detailsId", String(matched.company_productcode));
                                    window.sessionStorage.setItem("product_activeStatus", matched.active_status ?? "");
                                    window.open("/masters/products/details", "_blank");
                                  }
                                } catch (e) {
                                  console.error(e);
                                }
                              }}
                            >
                              {item?.item_code}
                            </span>
                          )}
                        </td>
                        {/* M10-14632 */}
                        <td className="px-1 py-2 border-t">{item?.item_description}</td>
                        <td className="px-1 py-2 border-t">{item?.inv_mrp}</td>
                        <td className="px-1 py-2 border-t">{item?.ptr}</td>
                        <td className="px-1 py-2 border-t">{item?.inv_rate}</td>
                        <td className="px-1 py-2 border-t">{item?.quantity}</td>
                        <td className="px-1 py-2 border-t">{item?.gross_amt}</td>
                        <td className="px-1 py-2 border-t">{item?.discount_type}</td>
                        <td className="px-1 py-2 border-t">{item?.discount_perc}</td>
                        <td className="px-1 py-2 border-t">{item?.discount_amt}</td>
                        <td className="px-1 py-2 border-t">{item?.free_qty}</td>
                        <td className="px-1 py-2 border-t">{item?.p_cash_discount_perc}</td>
                        <td className="px-1 py-2 border-t">{item?.p_gst_perc}</td>
                        <td className="px-1 py-2 border-t">{item?.batch_no}</td>
                        <td className="px-1 py-2 border-t">
                          <Button
                            disabled={invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 8 || item?.is_item_unknown || item?.preq_approved === false || invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 5 || (item?.mapped && item?.invoice_status === "fully_invoiced")}
                            onClick={() => {
                            handleViewDetails(selectedProducts.length > 0 ? selectedProducts?.[0] : item)
                            setIsConfirmScheme(true)  // M10-13377
                            // setRemainingQuantity([])
                            }}
                            className="w-fit h-8 font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0]"
                          >
                            View
                          </Button>
                        </td>
                        {/* <td className="px-4 py-2 border-t">
                      <Button onClick={() => handleProductDelete(item)}>
                        <img src={DeleteIcon} alt="delete" className="w-4 h-4" />
                      </Button>
                    </td> */}
                        {
                          <td className="px-4 py-2 border-t">
                            {item?.mapped && item?.invoice_status === "fully_invoiced" && (
                              <Button>
                                <img src={SuccessIcon} alt="counter_details_check" className="" />
                              </Button>
                            )}
                            {item?.mapped && item?.invoice_status === "partially_invoiced" && (
                              <Button>
                                <img src={PartialIcon} alt="counter_details_check" className="" />
                              </Button>
                            )}
                          </td>
                        }
                      </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          }
          {orderedData?.length === 0 && (
            <div className="mt-10 border border-[#d0d0d0] p-5 rounded-xl mx-4">
              <div className="flex items-center justify-between">
                <p className="text-lg font-semibold">{selectedItemDetails?.item_description || "Select an Item"}</p>
                <div className="flex items-center gap-2">
                  <div className="w-[200px]">
                    <Autocomplete
                      openDropdownOnMount={showOrderDropdown}
                      inputClassName="w-full"
                      placeholder="Choose an order"
                      // M10-15866: show the order(s) already linked to this invoice first in the
                      // dropdown, ahead of the other similar orders returned by the API.
                      suggestionList={[...(similarOrders || [])]
                        .sort((a: any, b: any) => {
                          const isLinked = (item: any) =>
                            invoiceApprovalData?.orderCodes?.some((order: any) => order?.order_code === item?.order?.order_code) ? 0 : 1;
                          return isLinked(a) - isLinked(b);
                        })
                        .map((item: any) => ({
                          id: item?.order?.order_code,
                          ...item,
                        }))}
                      currentSelected={selectedOrders?.[0]?.id || ""}
                      defaultValue={selectedOrders?.[0]?.id || ""}
                      uniqueKey="id"
                      displayKey="id"
                      onSelectionChange={(value: any) => {
                        const differentOrder = !invoiceApprovalData?.orderCodes?.some((order: any) => order?.order_code === value?.id);
                        const isKam = invoiceApprovalData?.module_code === 4; //M10-15732
                        const differentPoRef =
                          isKam && (invoiceApprovalData?.poid_ref_number || "") !== (value?.order?.poid_ref_number || ""); //M10-15732
                        if (differentOrder) {
                          setIsDifferentOrderModalOpen(true);
                          setOrderToSelect([value]);
                        } else if (differentPoRef) {
                          setIsDifferentPoRefModalOpen(true); //M10-15732
                          setOrderToSelect([value]);
                        } else {
                          setSelectedOrders([value]);
                          setShowOrderDropdown(false);
                        }
                      }}
                      inputRef={inputRef}
                    />
                  </div>
                  <div className="p-2 bg-[#F1F1F1] border-2 border-gray-200 rounded-md cursor-pointer" onClick={handleToggle}>
                    <img className={`transition-transform  duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
                  </div>
                </div>
              </div>
              <div
                className={`transition-all items-center duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
                style={{ transitionProperty: "max-height, opacity" }}
              >
                <table className="min-w-full mt-5 border border-gray-200">
                  <thead className="w-full bg-gray-100">
                    <tr>
                      <th className="px-4 py-2 text-sm font-normal text-left text-gray-600"></th>
                      <th className="px-4 py-2 text-sm font-normal text-left text-gray-600">Invoice Data</th>
                      <th className="px-4 py-2 text-sm font-normal text-left text-gray-600 align-top">
                        <div className="flex flex-col gap-1">
                          <span>
                            Ordered Data - <span className="text-[#8051FF]">{selectedOrders?.[0]?.id}</span>
                          </span>
                          {selectedOrders?.[0]?.order?.poid_ref_number && (
                            <span>
                              PO Ref No - <span className="text-[#8051FF]">{selectedOrders?.[0]?.order?.poid_ref_number}</span>
                            </span>
                          )}
                        </div>
                      </th>
                      <th className="px-4 py-2 text-sm font-normal text-left text-gray-600">Modified Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((item, index) => (
                      <tr key={index} className="h-12 text-sm">
                        <td className="px-4 py-2 text-gray-500 border-t">{item?.type}</td>
                        <td className={`px-4 py-2 border-t ${item.type === "Calculated Value" ? "text-red-600" : ""}`}>
                          {Number(getInvoiceDataDisplayValue(item))}
                        </td>
                        <td className="px-4 py-2 border-t">
                          {item?.orderedData}{" "}
                          {selectedOrders?.length > 0 && item?.type === "Quantity" && (
                            <span className="text-[#8051FF]">
                              (Remaining Qty:{" "}
                              {
                                remainingQuantity
                                  ?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]))
                                  ?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_quantity
                              }
                              )
                            </span>
                          )}
                          {selectedOrders?.length > 0 && item?.type === "Scheme Qty" && (
                            <span className="text-[#8051FF]">
                              (Remaining Free Qty:{" "}
                              {remainingQuantity
                                ?.find((item) => item?.unique_key === (similarOrders?.some((o: any) => o?.batch_number) ? selectedItemDetails?.unique_key?.split("~").slice(0, 4).join("~") : selectedItemDetails?.unique_key?.split("~")[0]))
                                ?.orders?.find((order: any) => order?.order_code === selectedOrders?.[0]?.id)?.remaining_free_quantity || 0}
                              )
                            </span>
                          )}
                        </td>
                        <td className="flex gap-2 px-4 py-2 border-t">
                          {item.type === "Calculated Value" || item.type === "Calculated Percentage"? (
                            <span className="w-full px-2 py-1 border-black text-red-600">
                              {item?.modifiedData === "-" ? "-" : (
                                <>
                                  {Number(item?.modifiedData)} (
                                  {(Number(item?.modifiedData) || 0) > 0 ? ( ( (Number(item?.modifiedData) - (Number(item?.invoiceData) || 0)) / Number(item?.modifiedData) ) * 100 ).toFixed(2) : "0.00" }%)
                                </>
                              )}
                            </span>
                          ) : (
                            <Input
                              disabled={item.type === "MRP" || item.type === "PTR"}
                              type="number"
                              placeholder="0"
                              enableArrows={false}
                              value={Number(item?.modifiedData)}
                              onChange={(e) => {
                                handleModifyData(index, e.target.value);
                              }}
                              onWheel={(e) => (e.target as HTMLInputElement).blur()}
                              className="w-full px-2 py-1 border rounded-md border-1-black"
                              isError={inputFieldValidationHandler(item)}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-end">
                {selectedItemDetails && (
                  <Button onClick={() => saveModifiedData(selectedOrders)} className="mt-4 h-9 font-normal text-white bg-[#8051FF] shadow-sm">
                    Save Modified Data
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>

        {orderedData?.length === 0 && (
          <div className="mt-10 border mx-[3.75rem] border-[#d0d0d0] p-5 rounded-xl px-10">

            <div className="flex items-center justify-between pb-5">
              <p className="text-lg font-semibold">Final Mapped Data</p>
              {/* <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
            <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
          </Button> */}
              <Button
                disabled={invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 8}
                className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                onClick={() => handleReset(invoiceApprovalData)}
              >
                Reset
              </Button>
            </div>

            <table className="min-w-full border border-gray-200">
              <thead className="w-full bg-gray-100">
                <tr>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">S.No</th> {/* M10-9670 */}
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Item Code</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Order Code</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Item description</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. MRP</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. PTR</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Price</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. Qty.</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Gross Amt.</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Inv. Scheme</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Discount %</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Cash Discount %</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Scheme Qty.</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">GST % </th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Batch</th>
                  <th className="px-1 py-2 text-sm text-left text-gray-600">Action</th>
                </tr>
              </thead>
              <tbody>
                {mappedData
                  ?.sort((a: any, b: any) => (a?.textractProduct?.stockistfile_detail_code || 0) - (b?.textractProduct?.stockistfile_detail_code || 0))
                  ?.map((item: any, index: any) => (
                    <tr
                      key={index}
                      className={`text-sm h-12`}
                      style={{ backgroundColor: uniqueKeyColorMap[item.unique_key?.split("~")?.slice(0, 5)?.join("~")] }}
                    >
                      <td className="px-1 py-2 border-t">{index + 1}</td> {/* M10-9670 */}
                      {/* M10-14632 */}
                      <td className="px-1 py-2 border-t">
                        {item?.is_item_unknown ? (
                          item?.item_code
                        ) : (
                          <span
                            className="text-[#7F56D9] cursor-pointer hover:underline"
                            onClick={async () => {
                              try {
                                const res = await searchProduct({
                                  search: item?.item_code,
                                  page: 1,
                                  perPage: 10,
                                  company_code: invoiceApprovalData?.company_code,
                                });
                                const matched = res?.data?.data?.find(
                                  (p: any) => p.item_code === item?.item_code
                                );
                                if (matched?.company_productcode) {
                                  window.sessionStorage.setItem("detailsId", String(matched.company_productcode));
                                  window.sessionStorage.setItem("product_activeStatus", matched.active_status ?? "");
                                  window.open("/masters/products/details", "_blank");
                                }
                              } catch (e) {
                                console.error(e);
                              }
                            }}
                          >
                            {item?.item_code}
                          </span>
                        )}
                      </td>
                      {/* M10-14632 */}
                      <td className="px-1 py-2 border-t">{item?.order_code}</td>
                      <td className="px-1 py-2 border-t">{item?.item_description}</td>
                      <td className="px-1 py-2 border-t">{item?.inv_mrp}</td>
                      <td className="px-1 py-2 border-t">{item?.ptr}</td>
                      <td className="px-1 py-2 border-t">{item?.inv_rate}</td>
                      <td className="px-1 py-2 border-t">{item?.quantity}</td>
                      <td className="px-1 py-2 border-t">{Number(item?.inv_rate * item?.quantity).toFixed(2)}</td>
                      <td className="px-1 py-2 border-t">{item?.discount_type}</td>
                      <td className="px-1 py-2 border-t">{Number(item?.discount_perc).toFixed(2)}</td>
                      <td className="px-1 py-2 border-t">{item?.p_cash_discount_perc}</td>
                      <td className="px-1 py-2 border-t">{item?.free_qty}</td>
                      <td className="px-1 py-2 border-t">{item?.p_gst_perc || 0}</td>
                      <td className="px-1 py-2 border-t">{item?.batch_no}</td>
                      <td className="px-1 py-2 border-t">
                        <Button
                          className="font-normal bg-[#F1F1F1] border-2 border-[#d0d0d0] shadow-sm h-8 focus:outline-none focus:ring-0 hover:text-gray-600"
                          onClick={() => {
                            const modifiedBaseKey = item.unique_key;
                            // Filter the mappedData to exclude the current item
                            const filteredMappedData = mappedData.filter((product: any) => product?.unique_key !== item?.unique_key);
                            // Check if another item with same modifiedBaseKey exists
                            const hasSameKeyInMapped = filteredMappedData.some((product: any) => product?.unique_key === modifiedBaseKey);
                            // Update productsData only if no same key exists in remaining mappedData

                            if (!hasSameKeyInMapped) {
                              setProductsData((prev) =>
                                prev.map((product) => {
                                  // Match the exact invoice line (item code~batch~MRP~price), the same 4-segment key the
                                  // mapping step uses — matching on item code alone added the deleted qty back to every
                                  // other batch/line of the same product too, flipping those to "mapped".
                                  if (product?.unique_key !== modifiedBaseKey?.split("~").slice(0, 4).join("~")) return product;
                                  const updatedUnmappedQty = product?.merged
                                    ? Number(product?.quantity)
                                    : Number(product?.unmappedQty) + Number(item?.quantity);
                                  const updatedUnmappedFreeQty = product?.merged
                                    ? Number(product?.free_qty)
                                    : Number(product?.unmappedFreeQty) + Number(item?.free_qty);

                                  let status = "fully_invoiced";

                                  if (updatedUnmappedQty === Number(product.quantity) && updatedUnmappedFreeQty === Number(product.free_qty)) {
                                    status = "not_invoiced";
                                  } else if (updatedUnmappedQty < product.quantity || updatedUnmappedFreeQty < product.free_qty) {
                                    status = "partially_invoiced";
                                  }

                                  return {
                                    ...product,
                                    mapped: status === "not_invoiced" ? false : true,
                                    unmappedQty: updatedUnmappedQty,
                                    unmappedFreeQty: updatedUnmappedFreeQty,
                                    invoice_status: status,
                                  };
                                })
                              );
                            }

                            // Remove the item from mappedData
                            setMappedData((prev: any[]) => prev?.filter((product: any) => product?.unique_key !== item?.unique_key));
                            // Update remaining quantity
                            setRemainingQuantity((prev: any[]) =>
                              prev.map((product: any) => {
                                // handleViewDetails keys the entry by `itemCode~batchNo` when
                                // similar orders carry batch numbers, otherwise by `itemCode`.
                                // similarOrders is cleared by the time Delete runs, so match
                                // against either format to ensure the decrement is reversed.
                                const fullKey = item.unique_key?.split("~").slice(0, 4).join("~");
                                const baseKey = item.unique_key?.split("~")[0]; //M10-14279

                                return product?.unique_key === fullKey || product?.unique_key === baseKey
                                  ? {
                                    ...product,

                                    orders:
                                      product?.orders?.map((order: any) =>
                                        order?.order_code === item?.order_code?.[0]
                                          ? {
                                            ...order,
                                            remaining_quantity: order?.remaining_quantity + item?.quantity,
                                            remaining_free_quantity: order?.remaining_free_quantity + item?.free_qty,
                                          }
                                          : order
                                      ) ?? [],
                                    remaining_invoice_quantity: product?.remaining_invoice_quantity + item?.quantity,
                                    remaining_invoice_free_quantity: product?.remaining_invoice_free_quantity + item?.free_qty,
                                  }
                                  : product;
                              })
                            );
                            //M10-11117
                            if (mappedData.length == 1) {
                              setIsMapped(true)
                            }
                            //M10-11117
                          }}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        {orderedData?.length > 0 && <InvoiceApprovalOrderedData orderData={orderedData} invoiceData={invoiceApprovalData}/>}
        <div className="p-6 mt-10 rounded-xl border border-[#d0d0d0] w-[360px] shadow-sm mx-[3.75rem]">
          <p className="mb-2 text-lg font-semibold">Calculations</p>
          <div className="flex flex-col pb-10 gap-y-1">
            <p className="flex justify-between py-2 text-sm">
              Entry Net Amount <span className="">₹ {Number(entryNetAmt).toLocaleString("en-IN")}</span>
            </p>
            <p className="flex justify-between py-2 text-sm">
              Subtotal{" "}
              <span className="">
                ₹ {orderedData?.length > 0 ? invoiceApprovalData?.invoice?.gross_amount : Number(calculateSubtotal().toFixed(2))}
              </span>
            </p>
            <p className="flex justify-between py-2 text-sm">
              <span className="mr-2">Cash Discount %</span>
              <div className="">
                <Input
                  type="number"
                  enableArrows={false}
                  showIcon={false}
                  disabled={true}
                  placeholder="0"
                  value={
                    orderedData?.length > 0 ? invoiceApprovalData?.invoice?.cash_discount_perc : calculateTotalCashDiscountPercentage()?.toFixed(2)
                  }
                  className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                />
              </div>
            </p>
            <p className="flex justify-between py-2 text-sm">
              <span className="mr-2">Cash Discount Amount</span>
              <div className="">
                <Input
                  type="number"
                  enableArrows={false}
                  showIcon={false}
                  disabled={true}
                  value={orderedData?.length > 0 ? invoiceApprovalData?.invoice?.cash_discount : calculateTotalCashDiscount()?.toFixed(2)}
                  className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                />
              </div>
            </p>
            <p className="flex justify-between py-2 text-sm">
              GST Amount
              <span className="font-semibold">
                ₹{orderedData?.length > 0 ? invoiceApprovalData?.invoice?.gst_amount : calculateTotalGst()?.toFixed(2)}
              </span>
            </p>
            <p className="flex justify-between py-2 text-sm">
              <span className="mr-2">TCS %</span>
              <div className="">
                <Input
                  enableArrows={false}
                  showIcon={false}
                  disabled={invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 8}
                  type="number"
                  placeholder="TCS"
                  value={orderedData?.length > 0 ? invoiceApprovalData?.invoice?.tcs_perc : tcs}
                  // value={Number(invoiceApprovalData?.invoice?.tcs_perc)}
                  onChange={(e: any) => setTcs(e?.target?.value)}
                  className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                />{" "}
              </div>
            </p>
            <p className="flex justify-between py-2 text-sm">
              Total (as calculated){" "}
              <span className="font-semibold">
                ₹{" "}
                {
                  calculateTotalAsFinal() ? Number(calculateTotalAsFinal().toFixed(2)) : Number(calculateTotal().toFixed(2))}
              </span>
            </p>
            {/* <p className="flex justify-between py-2 text-sm">
              Net Inv. Amt. <span className="">₹ {calculateSubtotal().toFixed(2)}</span>
            </p> */}
            {/* M10-10941 Only (Waiting For Approval)*/}
            {invoiceApprovalData?.fileStatusHdr?.fuid_status_id === 6 && (
              <Button
                disabled={isRequestInProgress.current}
                loaderSize="small"
                isLoading={isApproving}
                className="w-full h-9 mt-2 font-normal text-white bg-[#8051FF] shadow-sm"
                onClick={() => {
                  const fieldsToValidate = ["cash_discount", "discount_amt", "discount_perc", "free_qty", "gross_amt", "inv_mrp", "inv_rate", "net_amt", "p_cash_discount", "p_cash_discount_perc", "p_gst_amount", "p_gst_perc", "ptr", "pts", "quantity"];
                  const hasNegativeValues = mappedData?.some(product =>
                    fieldsToValidate?.some(field => {
                      const value = product[field];
                      return value != null && !isNaN(Number(value)) && Number(value) < 0;
                    })
                  );

                  if (hasNegativeValues) {
                    toast({
                      description: "Negative values are not allowed",
                      variant: "destructive",
                    });
                    return;
                  }
                  if (mappedData?.length == 0) {
                    toast({ description: "Please add products before approval", variant: "destructive" });
                    return;
                  }
                  if (Math.abs(Number(entryNetAmt) - Number(calculateTotal())) > 10) {
                    setOpenNetAmtModal(true);
                  } else {
                    handleApproveInvoice();
                  }
                }}
                module={fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].module}
                action={fineGrainedPermissionsKeys.INVOICE["UPDATE/APPROVEINVOICE"].action}
              >
                Approve Invoice
              </Button>
            )}
          </div>
        </div>
      </div>
      <Modal isOpen={revertInvoiceOpen} isHeader={false} onCloseModal={() => setRevertInvoiceOpen(false)}>
        <RevertInvoice
          onSuccess={() => {
            navigate("/transactions/invoice/1");
          }}
          onCloseModal={() => setRevertInvoiceOpen(false)}
        />
      </Modal>
      <Modal isOpen={recallInvoiceOpen} isHeader={false} onCloseModal={() => setRecallInvoiceOpen(false)}>
        <RecallInvoice
          onSuccess={() => {
            navigate("/transactions/invoice/1");
          }}
          onCloseModal={() => setRecallInvoiceOpen(false)}
        />
      </Modal>
      <Modal isOpen={rejectInvoiceOpen} isHeader={false} onCloseModal={() => setRejectInvoiceOpen(false)} title="Reject Invoice">
        <InvoiceReject
          tab={"approval"}
          invoiceData={invoiceApprovalData}
          onCloseModal={() => setRejectInvoiceOpen(false)}
          onSuccess={() => fetchInvoiceDetails()}
        />
      </Modal>
      <Modal isOpen={openNetAmtModal} isHeader={false} onCloseModal={() => setOpenNetAmtModal(false)} title="Escalate Invoice">
        <NetAmountCompare
          handleApproveInvoice={handleApproveInvoice}
          calculatedTotal={calculateTotal().toFixed(2)}
          entryNetAmount={entryNetAmt}
          onCloseModal={() => setOpenNetAmtModal(false)}
          isLoading={isApproving}
          unknownAmount={unknownCalculation()}  // M10-13191
        />
      </Modal>
      <Modal isOpen={isDifferentOrderModalOpen} isHeader={false} onCloseModal={() => setIsDifferentOrderModalOpen(false)} title="Is Different Order">
        <IsDifferentOrder
          handleApproveInvoice={() => {
            setIsDifferentOrderModalOpen(false);
            //M10-15732: KAM PO-digitized invoices also need the PO Ref No confirmed before mapping
            const isKam = invoiceApprovalData?.module_code === 4;
            const differentPoRef =
              isKam && (invoiceApprovalData?.poid_ref_number || "") !== (orderToSelect?.[0]?.order?.poid_ref_number || "");
            if (differentPoRef) {
              setIsDifferentPoRefModalOpen(true);
            } else {
              setSelectedOrders(orderToSelect);
              setShowOrderDropdown(false);
            }
          }}
          onCloseModal={() => {
            setOrderToSelect([]);
            setIsDifferentOrderModalOpen(false);
          }}
          invoiceOrderCode={invoiceApprovalData?.orderCodes?.map((order: any) => order?.order_code)?.join(",")}
          selectedOrderCode={orderToSelect?.[0]?.id}
        />
      </Modal>
      <Modal isOpen={openPerStripModal} isHeader={false} onCloseModal={() => resumePerStripSave(false)} title="Order Pack Change">
        <PerStripOrderEdit
          message={packChangeMessage}
          onCloseModal={() => resumePerStripSave(false)}
          onConfirm={() => resumePerStripSave(true)}
          onDecline={() => resumePerStripSave(false)}
        />
      </Modal>
      {/* M10-15732 */}
      <Modal isOpen={isDifferentPoRefModalOpen} isHeader={false} onCloseModal={() => setIsDifferentPoRefModalOpen(false)} title="Is Different PO Ref No">
        <IsDifferentPoRef
          handleConfirm={() => {
            setSelectedOrders(orderToSelect);
            setShowOrderDropdown(false);
            setIsDifferentPoRefModalOpen(false);
          }}
          onCloseModal={() => {
            setOrderToSelect([]);
            setIsDifferentPoRefModalOpen(false);
          }}
          invoicePoRefNo={invoiceApprovalData?.poid_ref_number}
          selectedPoRefNo={orderToSelect?.[0]?.order?.poid_ref_number}
        />
      </Modal>
      {/* M10-15732 */}
      {/* M10-12438 */}
      <PORemoveModalReusable
        isOpen={removePOmodel}
        onClose={() => setRemovePOmodel(false)}
        data={orderedData}
        onRemove={handleRemove}
      />
      {/* M10-12438 */}

      {isFeedbackModalOpen && (
        <Modal isOpen={isFeedbackModalOpen} isHeader={true} title="Feedback" onCloseModal={() => setIsFeedbackModalOpen(false)}>
          <AddFeedbackForm
            onFormSubmit={handleFormSubmit}
            defaultValues={{ reference_number: invoiceApprovalData?.fuid_no, type: { name: "Invoices", id: "invoice" } }}
            isLoading={loading}
          />
        </Modal>
      )}
      {/* M10-13377 */}
      <Modal
        isOpen={showVerifyModal}
        isHeader={false}
        onCloseModal={() => setShowVerifyModal(false)}
        title="Verify"
      >
        <div className="flex flex-col gap-y-2 mb-4 w-[540px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">

          {/* Header */}
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold text-gray-800">
              Please verify before continuing.
            </p>

            <Button
              className="bg-transparent -mr-3"
              onClick={() => setShowVerifyModal(false)}
            >
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          {/* Table */}
          <div className="overflow-y-auto max-h-[400px] mt-2">
            <table className="w-full text-sm text-gray-700 border border-gray-200 rounded">
              <thead className="bg-gray-100 text-left sticky top-0 z-10">
                <tr>
                  <th className="p-2 border-b">Type</th>
                  <th className="p-2 border-b">Invoice Free Qty</th>
                  <th className="p-2 border-b">Modified Free Qty</th>
                  <th className="p-2 border-b">Verify</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="p-3 border-b">{verifyData?.type}</td>
                  <td className="p-3 border-b">{verifyData?.invoiceData}</td>
                  <td className="p-3 border-b">{verifyData?.modifiedData}</td>

                  <td className="p-3 border-b">
                    <Toggle
                      checked={isVerified}
                      onChange={(checked) => setIsVerified(checked)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Footer Buttons */}
          <div className="flex justify-end gap-2 mt-4">
            <Button
              className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg"
              onClick={() => {
                setIsVerified(false);
                setShowVerifyModal(false);
              }}
            >
              Cancel
            </Button>

            <Button
              disabled={!isVerified}
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => {
                setShowVerifyModal(false);
                setIsConfirmScheme(false);
                setIsVerified(false)
              }}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
      {/* M10-13377 */}
    </InvoiceLayout>
  );
};
